var _g, _g2, _g3, _g4, _g5, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g6, _path11, _g7, _g8, _g9, _ellipse, _path12, _path13, _g10, _path14, _path15, _path16, _g11, _path17, _path18, _ellipse2, _path19, _path20, _path21, _path22, _g12, _path23, _path24, _path25, _path26, _path27, _g13, _path28, _g14, _path29, _path30, _path31, _path32, _path33, _path34, _g15, _path35, _path36, _g16, _g17, _path37, _path38, _path39, _path40, _path41, _path42, _g18, _g19, _path43, _path44, _g20, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 365.721,
    height: 261.984,
    viewBox: "0 0 365.721 261.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "network",
    transform: "translate(0 -44.444)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(0 44.444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1484",
    "data-name": "Group 1484",
    transform: "translate(0 7.353)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_128",
    "data-name": "Rectangle 128",
    width: 365.721,
    height: 0.175,
    transform: "translate(0 229.107)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 24.227,
    height: 0.175,
    transform: "translate(304.849 240.369)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 6.359,
    height: 0.175,
    transform: "translate(235.91 242.268)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 14.038,
    height: 0.175,
    transform: "translate(290.079 233.872)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 31.593,
    height: 0.175,
    transform: "translate(38.371 235.048)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_133",
    "data-name": "Rectangle 133",
    width: 4.632,
    height: 0.175,
    transform: "translate(76.476 235.048)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_134",
    "data-name": "Rectangle 134",
    width: 68.518,
    height: 0.175,
    transform: "translate(96.164 238.002)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M183.623,252.856H42.382a4.092,4.092,0,0,1-4.175-3.994V58.946a4.092,4.092,0,0,1,4.175-3.993H183.623a4.092,4.092,0,0,1,4.174,3.993V248.862A4.092,4.092,0,0,1,183.623,252.856ZM42.382,55.128a3.912,3.912,0,0,0-3.992,3.818V248.862a3.912,3.912,0,0,0,3.992,3.819H183.623a3.912,3.912,0,0,0,3.991-3.819V58.946a3.912,3.912,0,0,0-3.991-3.818Z",
    transform: "translate(-10.261 -54.953)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M399.919,252.856H258.679a4.092,4.092,0,0,1-4.174-3.994V58.946a4.091,4.091,0,0,1,4.174-3.993h141.24a4.092,4.092,0,0,1,4.176,3.993V248.862A4.093,4.093,0,0,1,399.919,252.856ZM258.679,55.128a3.912,3.912,0,0,0-3.991,3.818V248.862a3.912,3.912,0,0,0,3.991,3.819h141.24a3.913,3.913,0,0,0,3.993-3.819V58.946a3.913,3.913,0,0,0-3.993-3.818Z",
    transform: "translate(-68.349 -54.953)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M336.667,117.123,257.054,91.4l-.061-.06L214.932,50.1,181.2,79.573l-.494-.517,34.253-29.927,42.494,41.663,78.937,25.5,32.4-42.636.591.411Z",
    transform: "translate(-48.531 -45.851)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1485",
    "data-name": "Group 1485",
    transform: "translate(32.808)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M52.724,235.172a3.939,3.939,0,1,1-3.934-3.764A3.852,3.852,0,0,1,52.724,235.172Z",
    transform: "translate(-44.854 -100.593)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M230.008,48.208a3.939,3.939,0,1,1-3.935-3.764A3.853,3.853,0,0,1,230.008,48.208Z",
    transform: "translate(-92.465 -44.444)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M440.742,82.866a3.939,3.939,0,1,1-3.934-3.764A3.852,3.852,0,0,1,440.742,82.866Z",
    transform: "translate(-149.06 -54.852)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M441.21,366.769a3.939,3.939,0,1,1-3.934-3.764A3.852,3.852,0,0,1,441.21,366.769Z",
    transform: "translate(-149.185 -140.114)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M287.85,107.494a3.939,3.939,0,1,1-3.935-3.764A3.852,3.852,0,0,1,287.85,107.494Z",
    transform: "translate(-107.999 -62.249)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M155.009,290.564l-.305-.055L56.019,272.684l.136-.687,98.381,17.769,68.89-180.828.687.24Z",
    transform: "translate(-15.044 -63.813)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M0,0,.714.016l.969,44.118-.714-.016Z",
    transform: "matrix(0.663, -0.749, 0.749, 0.663, 45.212, 62.425)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M420.543,301.75l-48.79-28.925,1.065-.279,51.261-47.175L387.5,145.8l.669-.282,36.783,80.021-.184.169L373.4,272.98l47.527,28.176Z",
    transform: "translate(-99.837 -74.797)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M54.65,291.9l-.614-.38,29.488-43.572-34-30.167.248-.256,42.582-44.1.253.14,194.04,107.377-.366.605L92.5,174.306,50.561,217.738,84.472,247.83Z",
    transform: "translate(-13.301 -83.178)",
    fill: "#f0f0f0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "World",
    transform: "translate(121.714 109.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1491",
    "data-name": "Group 1491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1490",
    "data-name": "Group 1490"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1486",
    "data-name": "Group 1486"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M220.966,250.387q2.951.233,5.847.19A60.618,60.618,0,0,0,269.2,232.65a55.533,55.533,0,0,0,15.92-34.261c.03-.346.056-.691.08-1.033a54.429,54.429,0,0,0-2.531-20.506v0c-6.411-19.728-23.81-35.135-45.874-39.055q-2.966-.524-6.034-.77a62.089,62.089,0,0,0-14.464.537A60.254,60.254,0,0,0,181.058,156.3a55.436,55.436,0,0,0-14.45,32.712,54.386,54.386,0,0,0,1.831,19.488C174.777,231,195.291,248.356,220.966,250.387Z",
    transform: "translate(-166.403 -136.823)",
    fill: "#ff725e"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1487",
    "data-name": "Group 1487",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M220.966,250.387q2.951.233,5.847.19A60.618,60.618,0,0,0,269.2,232.65a55.533,55.533,0,0,0,15.92-34.261c.03-.346.056-.691.08-1.033a54.429,54.429,0,0,0-2.531-20.506v0c-6.411-19.728-23.81-35.135-45.874-39.055q-2.966-.524-6.034-.77a62.089,62.089,0,0,0-14.464.537A60.254,60.254,0,0,0,181.058,156.3a55.436,55.436,0,0,0-14.45,32.712,54.386,54.386,0,0,0,1.831,19.488C174.777,231,195.291,248.356,220.966,250.387Z",
    transform: "translate(-166.403 -136.823)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1488",
    "data-name": "Group 1488",
    transform: "translate(2.036 0.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M182.081,230.655c-.192,1.057-1.6,1.437-2.73,1.574q-2.551.3-5.1.607c-.8-2.021-3.3-2.038-5.063-1.251,6.338,22.5,26.851,39.852,52.527,41.883q2.951.233,5.847.19a1.647,1.647,0,0,0,.1-.139c.886-1.49-.4-2.81-1.088-4.032-.155-.276-1.613-3.8-1.129-3.809a16.407,16.407,0,0,1-4.631-.573.472.472,0,0,1-.3-.169c-.141-.233.2-.46.472-.522.7-.157,1.428-.193,2.116-.39a2.418,2.418,0,0,0,1.634-1.237,12.006,12.006,0,0,0,.224-2.053,2.877,2.877,0,0,1,1.684-1.837,10.041,10.041,0,0,1,2.456-.626c-1.8-.935-.489-2.885-1.9-4.188-.452-.418-1.113-.93-.834-1.47.264-.514,1.215-.506,1.333-1.068.083-.393-.35-.716-.758-.8a4.653,4.653,0,0,1-1.222-.25,1.021,1.021,0,0,1-.345-1.46c.307-.411.875-.538,1.341-.776s.888-.789.608-1.218a.822.822,0,0,0-.27-.242,2.5,2.5,0,0,0-2.5.4,4.623,4.623,0,0,1-2.393,1.068.7.7,0,0,1,.293-.967,1.267,1.267,0,0,0,.363-.179c.209-.2.052-.54-.091-.791a4.927,4.927,0,0,1-.41-3.906l5.444.1c.045-.39.09-.623.522-.742a54.765,54.765,0,0,1-3.622-4.2,1.083,1.083,0,0,0-.486-.449,3.647,3.647,0,0,0-.713-.035c-.786-.1-.912-1.129-.832-1.883-.11-.229-.5-.13-.641.08s-.179.483-.356.67a1.047,1.047,0,0,1-1.1.114,2.464,2.464,0,0,1-1.382-3.244.766.766,0,0,1,.3-.36c.311-.17.687.039,1.039.1,1.389.239,1.178-1.229.843-1.924a4.342,4.342,0,0,0-2.788-1.789c-1.148-.281-8.8-1.681-7.542-4.069a1.142,1.142,0,0,1,.59-.476,18.292,18.292,0,0,1,2.338-.426c.766-.207,1.51-.97,1.175-1.661-.134-.277-.411-.467-.566-.735-.432-.744.233-1.709-.073-2.508a6.785,6.785,0,0,0-.673-.977c-.2-.339-.238-.849.11-1.052.392-.227.929.111,1.347-.069a.671.671,0,0,0,.009-1.136,1.286,1.286,0,0,0-1.354.1,1.684,1.684,0,0,1-.653.346c-.448.057-.781-.369-1.009-.741l-1.088-1.775a1.039,1.039,0,0,0-.864.735c-.14.369-.167.772-.327,1.136-.77,1.754-3.561,1.546-3.2,3.947a1.155,1.155,0,0,1,1.212,1.413c-.291.849-1.625,1.315-1.438,2.191.065.305.319.552.369.859.141.848-1.23,1.159-1.818,1.352-1.952.64-2.085-.586-3.776-.658-.774-.034-1.469.466-2.238.546-.709.075-1.413-.212-2.125-.172-1.956.109-.975,2.645-.837,3.747-1.051-.67-2.455.112-3.291,1.015-1.284,1.386-1.164,1.142-2.865,1.2a1.246,1.246,0,0,0-1.1.621c-.317.684.356,1.422.374,2.17.008.359-.138.712-.1,1.07.09.939,1.253,1.348,1.958,2.007a2.508,2.508,0,0,1,.754,2.266,5.879,5.879,0,0,1-1.5-.1l-.883-1.63a3.528,3.528,0,0,0-.993-1.3,3.054,3.054,0,0,1-.754-.545c-.371-.488-.071-1.157.017-1.753.214-1.448-.547-3.883-.917-5.32-.395-1.531-1.458-2.133-1.844-3.546a.471.471,0,0,0-.666-.2.969.969,0,0,0-.421.634,2.568,2.568,0,0,0,.162,1.751c-.339-.714-2.226,1.164-2.339,1.521-.187.584.218,1.416.2,2.023-.039,1.5-.419,2.35-2.045,1.243-.622-.423-1.418-.922-2.077-.554a.929.929,0,0,1-.548,1.064,2.164,2.164,0,0,1-1.322.1,1.343,1.343,0,0,1-.8-.373,2.111,2.111,0,0,0-.293-.369c-.417-.311-.943.228-1.17.685",
    transform: "translate(-169.187 -160.637)",
    fill: "#ff725e",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M277.431,163.291c.329.493-.018,1.135-.393,1.6s-.813,1-.649,1.567l2.117.185a.525.525,0,0,1,.364.129.471.471,0,0,1,.058.372q-.083.651-.165,1.3c-.446.332-.876-.715-1.43-.611-.245.046-.37.3-.5.5-1.146,1.718-3.145.431-4.216-.462-1.242-1.037-3.042-1.1-4.693-1.122a2.322,2.322,0,0,0-1.662.418c-.41.391-.434,1.01-.641,1.534-.355.907-1.265,1.5-1.78,2.336-1.8,2.919,1.436,5.163,4.186,4.369,1.426-.411,1.181-.65,2.638-.25.607.167,1.352.024,1.724.669a1.088,1.088,0,0,1-.992,1.581,5.038,5.038,0,0,1-2.344-.261,8.348,8.348,0,0,1-.105,2.955,1.306,1.306,0,0,0-1.439,1.722c.464.007,1.092.174,1.053.616a.726.726,0,0,1-.163.351c-.323.444-.737.828-1.016,1.3-.426.727-.423,2.9-1.512,3.165-.192.046-.4.031-.584.088a.834.834,0,0,0-.534.973,1.167,1.167,0,0,0,.862.8c.271.069.56.062.825.15,1.407.469.172,1.8.508,2.454a12.524,12.524,0,0,0,2.8,1.785,3.161,3.161,0,0,0-1.584,2.39c-.033,1.094.837,1.625,1.925,1.95,1.149.344,2.542.458,3.37.763a1.472,1.472,0,0,0,1.363.034c.467-.353.365-1.186.9-1.428a1.716,1.716,0,0,1,.557-.087,2.025,2.025,0,0,0,1.791-2.258c.256-.318.754-.288,1.174-.278s.951-.121,1.012-.518c.07-.457-.541-.711-1.023-.738a5.551,5.551,0,0,0-1.467.112,1.819,1.819,0,0,1-1.081.042,1.37,1.37,0,0,1-.566-.569,2.983,2.983,0,0,1-.6-1.8,1.338,1.338,0,0,1,1.262-1.253,2.9,2.9,0,0,0,.537.031c.456-.071.654-.607.627-1.047a3.794,3.794,0,0,1-.058-1.315c.125-.425.742-.741,1.049-.411.258-.565.429-1.386-.149-1.658a1.808,1.808,0,0,0-.607-.1c-1.272-.114-2.99-1.761-1.577-2.7.929-.616,2.429.669,3.245-.5.391-.558.149-1.371.55-1.922.238-.164.516.167.568.443a2.535,2.535,0,0,1-.886,2.393c.714.4,1.845-.056,2.33.585s-.23,1.732.4,2.226a1.355,1.355,0,0,0,.657.212c1.143.162,3.28-.024,3.35,1.543a2.15,2.15,0,0,0,.036.567c.176.552.96.6,1.56.548.309-.565-.094-1.224-.36-1.807s-.248-1.478.4-1.625c.464-.1,1.005.277,1.4.017.181-.121.265-.352.46-.451.473-.24.872.456,1.381.612.7.214,1.235-.667,1.235-1.372s-.184-1.508.3-2.042c.153-.169.357-.288.524-.444a2.912,2.912,0,0,0,.691-1.908c.116-1.093,4.626,1.738,4.91,1.783,2.169.346,3.5-1.711,4.985-2.837a13.421,13.421,0,0,1,2.589-1.4c-6.173-18.994-22.8-33.911-43.05-38.485a20.023,20.023,0,0,0-2.76-.511c.279,1.322,1.133,3.409.206,4.663-1.178,1.594-3.671.2-4.588,2.068-.031.476.8.4,1.184.7a1.632,1.632,0,0,1,.373.7c.106.246.355.493.62.416.309.441-.172.984-.581,1.343a3.468,3.468,0,0,0-1.113,1.513c-.379,1.25.48,2.491,1.03,3.68a16.485,16.485,0,0,1,.965,3.086c.008-.5.744-.7,1.208-.471a5.246,5.246,0,0,1,1.123,1.024c.64.587,1.467.231,2.156.733.858.621,1.406,1.737,2.465,1.905,1.284.206,2.216-1.1,2.786-2.219,1.411.715,2.283,2.44,3.877,2.553a4.251,4.251,0,0,0,1.777-.392q1.753-.659,3.5-1.32a2.27,2.27,0,0,1,1.508-.2,2.13,2.13,0,0,1,1.1,1.333l.755,1.757a1.223,1.223,0,0,1,.14.758,1.137,1.137,0,0,1-.561.609,6.562,6.562,0,0,1-4.538.886,23.565,23.565,0,0,0,1.238,5.958c-1.193-.3-2.565.085-3.67-.355",
    transform: "translate(-192.7 -137.996)",
    fill: "#ff725e",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M264.846,239.37a2.4,2.4,0,0,1-1.793.88,11.691,11.691,0,0,1-1.262-.228,1.2,1.2,0,0,0-1.156.367c-.3.438-.015,1.014.267,1.462a1.768,1.768,0,0,0,.926.874,8.928,8.928,0,0,0,.971.052c.636.1,1.043.674,1.464,1.139s1.111.884,1.672.582c.369-.2.528-.645.886-.861.874-.527,1.949.619,2.741.187.938-.511.595-1.973.206-2.8a7.654,7.654,0,0,0-1.867-2.1C266,237.162,266.267,237.75,264.846,239.37Z",
    transform: "translate(-193.712 -167.897)",
    fill: "#ff725e",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M303.479,255.931c9.354-8.867,14.825-21.789,15.9-34.215.03-.346.056-.691.08-1.033-1.8-1.78-5.4-2.915-6.338.286-.371-.026-.447-.236-.729-.437-.443-.314-1.066.112-1.314.584-.816,1.546-.928,3.487-3.169,3.07-2.671-.5-.859-1.591-1.73-3a2.969,2.969,0,0,0-.522-.5,2.79,2.79,0,0,1-.425-2.477,1.052,1.052,0,0,0,1.4-.559,1.538,1.538,0,0,1,.206-.587c.3-.341.927-.022,1.072.4a12.332,12.332,0,0,1,.131,1.333c.1.438.6.868,1,.635a.78.78,0,0,0,.313-.46,2.353,2.353,0,0,0-.459-2.217.971.971,0,0,0-.044-1.905c-.65-.136-1.58.232-1.843-.354a1.385,1.385,0,0,1-.573,1.368c-1.725,1.2-5.6.131-5.217,3.645a12.885,12.885,0,0,1,.255,1.683,1.3,1.3,0,0,1-.922,1.3c1.047.808.664,2.659,1.789,3.365a1.478,1.478,0,0,0,1.745-.177.635.635,0,0,1,.246-.185c.2-.062.395.123.6.167.364.074.68-.287,1.052-.306.519-.028.8.566.894,1.056s.23,1.089.731,1.223c.171.045.355.023.526.069a.851.851,0,0,1,.57.791,2.393,2.393,0,0,1-.236.993c-.216.209-.6.081-.81-.134a5.762,5.762,0,0,0-.574-.684c-.135-.1-3.243.127-3.145-.089-.462,1.024-.7,3.264-2.3,2.693-.567-.2-1.145-.569-1.725-.4q.414-1.085.8-2.179c-.235-.2-.6.073-.7.358s-.116.63-.366.811a1.047,1.047,0,0,1-.636.124l-2.151-.041a2.679,2.679,0,0,0-2.158.6,1.818,1.818,0,0,0,.354,2.31c.141.152.307.319.292.522a.762.762,0,0,1-.309.449,3.006,3.006,0,0,0-1.056,2.606,2.071,2.071,0,0,0,2.094,1.719c.388-.033.87-.157,1.1.144.134.177.13.463.339.553.263.113.483-.2.671-.41a1.2,1.2,0,0,1,1.419-.22,5.335,5.335,0,0,1,.76,2.55c-.429.7-2.465.426-3.261.46a1.19,1.19,0,0,0-.854.264c-.315.347-.059.9.293,1.212s.813.556.988.984a1.829,1.829,0,0,1,.078.792,1.968,1.968,0,0,1-.514,1.5c-.2.164-.462.25-.663.414a1.518,1.518,0,0,0-.333,1.611c.16.557.473,1.071.584,1.639.237,1.209-.457,2.522.045,3.654.242.547,1,.984,1.472.6.408-.333.4-1.119.938-1.176.511-.055,1.145,1.178,1.569,1.417.336.19,1.013-.123,1.63.3C302.838,254.789,302.94,255.554,303.479,255.931Z",
    transform: "translate(-202.694 -160.882)",
    fill: "#ff725e",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M195.192,157.138c.526-.64.857-1.377,1.845-1.541,1.345-.225,1.854.5,1.265,1.717a.527.527,0,0,0-.079.344c.092.372.673.155,1-.059a2.781,2.781,0,0,1,2.581-.119,11.544,11.544,0,0,0,.369-3.853c-.672-1.419-3.782-.751-3.144-2.295,1.164-.024,2.356.121,3.525.2l.192-1.611c-.048.4,2.126.318,2.372.2.957-.465.7-2.131,2.414-1.86,2.173.343,2.3,4.428-.173,3.761a10.2,10.2,0,0,0-.88,3.957c-.447,0-.9-.008-1.344-.014a1.12,1.12,0,0,0-.165,1.039,3.488,3.488,0,0,0,3.709.034c.705.517,1.7.022,2.429-.47a2.861,2.861,0,0,0,4.684-.351c.752-1.7-1.117-3.853-3-3.461a4.021,4.021,0,0,0-.916-2.375,5.624,5.624,0,0,0,5.373-3.561c.377-1.064.462-2.353,1.4-3.029.416-.3.944-.428,1.38-.7a3.964,3.964,0,0,0,1.413-2.969q.15-1.121.221-2.247a60.254,60.254,0,0,0-35.242,18.748,2.163,2.163,0,0,0,.089,1.159,2.6,2.6,0,0,0,1.864,1.1c2.852.721,4.675.564,6.652-1.558C195.087,157.263,195.14,157.2,195.192,157.138Z",
    transform: "translate(-173.807 -137.871)",
    fill: "#ff725e",
    style: {
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1489",
    "data-name": "Group 1489",
    transform: "translate(2.036 0.733)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M182.081,230.655c-.192,1.057-1.6,1.437-2.73,1.574q-2.551.3-5.1.607c-.8-2.021-3.3-2.038-5.063-1.251,6.338,22.5,26.851,39.852,52.527,41.883q2.951.233,5.847.19a1.647,1.647,0,0,0,.1-.139c.886-1.49-.4-2.81-1.088-4.032-.155-.276-1.613-3.8-1.129-3.809a16.407,16.407,0,0,1-4.631-.573.472.472,0,0,1-.3-.169c-.141-.233.2-.46.472-.522.7-.157,1.428-.193,2.116-.39a2.418,2.418,0,0,0,1.634-1.237,12.006,12.006,0,0,0,.224-2.053,2.877,2.877,0,0,1,1.684-1.837,10.041,10.041,0,0,1,2.456-.626c-1.8-.935-.489-2.885-1.9-4.188-.452-.418-1.113-.93-.834-1.47.264-.514,1.215-.506,1.333-1.068.083-.393-.35-.716-.758-.8a4.653,4.653,0,0,1-1.222-.25,1.021,1.021,0,0,1-.345-1.46c.307-.411.875-.538,1.341-.776s.888-.789.608-1.218a.822.822,0,0,0-.27-.242,2.5,2.5,0,0,0-2.5.4,4.623,4.623,0,0,1-2.393,1.068.7.7,0,0,1,.293-.967,1.267,1.267,0,0,0,.363-.179c.209-.2.052-.54-.091-.791a4.927,4.927,0,0,1-.41-3.906l5.444.1c.045-.39.09-.623.522-.742a54.765,54.765,0,0,1-3.622-4.2,1.083,1.083,0,0,0-.486-.449,3.647,3.647,0,0,0-.713-.035c-.786-.1-.912-1.129-.832-1.883-.11-.229-.5-.13-.641.08s-.179.483-.356.67a1.047,1.047,0,0,1-1.1.114,2.464,2.464,0,0,1-1.382-3.244.766.766,0,0,1,.3-.36c.311-.17.687.039,1.039.1,1.389.239,1.178-1.229.843-1.924a4.342,4.342,0,0,0-2.788-1.789c-1.148-.281-8.8-1.681-7.542-4.069a1.142,1.142,0,0,1,.59-.476,18.292,18.292,0,0,1,2.338-.426c.766-.207,1.51-.97,1.175-1.661-.134-.277-.411-.467-.566-.735-.432-.744.233-1.709-.073-2.508a6.785,6.785,0,0,0-.673-.977c-.2-.339-.238-.849.11-1.052.392-.227.929.111,1.347-.069a.671.671,0,0,0,.009-1.136,1.286,1.286,0,0,0-1.354.1,1.684,1.684,0,0,1-.653.346c-.448.057-.781-.369-1.009-.741l-1.088-1.775a1.039,1.039,0,0,0-.864.735c-.14.369-.167.772-.327,1.136-.77,1.754-3.561,1.546-3.2,3.947a1.155,1.155,0,0,1,1.212,1.413c-.291.849-1.625,1.315-1.438,2.191.065.305.319.552.369.859.141.848-1.23,1.159-1.818,1.352-1.952.64-2.085-.586-3.776-.658-.774-.034-1.469.466-2.238.546-.709.075-1.413-.212-2.125-.172-1.956.109-.975,2.645-.837,3.747-1.051-.67-2.455.112-3.291,1.015-1.284,1.386-1.164,1.142-2.865,1.2a1.246,1.246,0,0,0-1.1.621c-.317.684.356,1.422.374,2.17.008.359-.138.712-.1,1.07.09.939,1.253,1.348,1.958,2.007a2.508,2.508,0,0,1,.754,2.266,5.879,5.879,0,0,1-1.5-.1l-.883-1.63a3.528,3.528,0,0,0-.993-1.3,3.054,3.054,0,0,1-.754-.545c-.371-.488-.071-1.157.017-1.753.214-1.448-.547-3.883-.917-5.32-.395-1.531-1.458-2.133-1.844-3.546a.471.471,0,0,0-.666-.2.969.969,0,0,0-.421.634,2.568,2.568,0,0,0,.162,1.751c-.339-.714-2.226,1.164-2.339,1.521-.187.584.218,1.416.2,2.023-.039,1.5-.419,2.35-2.045,1.243-.622-.423-1.418-.922-2.077-.554a.929.929,0,0,1-.548,1.064,2.164,2.164,0,0,1-1.322.1,1.343,1.343,0,0,1-.8-.373,2.111,2.111,0,0,0-.293-.369c-.417-.311-.943.228-1.17.685",
    transform: "translate(-169.187 -160.637)",
    fill: "#fff",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M277.431,163.291c.329.493-.018,1.135-.393,1.6s-.813,1-.649,1.567l2.117.185a.525.525,0,0,1,.364.129.471.471,0,0,1,.058.372q-.083.651-.165,1.3c-.446.332-.876-.715-1.43-.611-.245.046-.37.3-.5.5-1.146,1.718-3.145.431-4.216-.462-1.242-1.037-3.042-1.1-4.693-1.122a2.322,2.322,0,0,0-1.662.418c-.41.391-.434,1.01-.641,1.534-.355.907-1.265,1.5-1.78,2.336-1.8,2.919,1.436,5.163,4.186,4.369,1.426-.411,1.181-.65,2.638-.25.607.167,1.352.024,1.724.669a1.088,1.088,0,0,1-.992,1.581,5.038,5.038,0,0,1-2.344-.261,8.348,8.348,0,0,1-.105,2.955,1.306,1.306,0,0,0-1.439,1.722c.464.007,1.092.174,1.053.616a.726.726,0,0,1-.163.351c-.323.444-.737.828-1.016,1.3-.426.727-.423,2.9-1.512,3.165-.192.046-.4.031-.584.088a.834.834,0,0,0-.534.973,1.167,1.167,0,0,0,.862.8c.271.069.56.062.825.15,1.407.469.172,1.8.508,2.454a12.524,12.524,0,0,0,2.8,1.785,3.161,3.161,0,0,0-1.584,2.39c-.033,1.094.837,1.625,1.925,1.95,1.149.344,2.542.458,3.37.763a1.472,1.472,0,0,0,1.363.034c.467-.353.365-1.186.9-1.428a1.716,1.716,0,0,1,.557-.087,2.025,2.025,0,0,0,1.791-2.258c.256-.318.754-.288,1.174-.278s.951-.121,1.012-.518c.07-.457-.541-.711-1.023-.738a5.551,5.551,0,0,0-1.467.112,1.819,1.819,0,0,1-1.081.042,1.37,1.37,0,0,1-.566-.569,2.983,2.983,0,0,1-.6-1.8,1.338,1.338,0,0,1,1.262-1.253,2.9,2.9,0,0,0,.537.031c.456-.071.654-.607.627-1.047a3.794,3.794,0,0,1-.058-1.315c.125-.425.742-.741,1.049-.411.258-.565.429-1.386-.149-1.658a1.808,1.808,0,0,0-.607-.1c-1.272-.114-2.99-1.761-1.577-2.7.929-.616,2.429.669,3.245-.5.391-.558.149-1.371.55-1.922.238-.164.516.167.568.443a2.535,2.535,0,0,1-.886,2.393c.714.4,1.845-.056,2.33.585s-.23,1.732.4,2.226a1.355,1.355,0,0,0,.657.212c1.143.162,3.28-.024,3.35,1.543a2.15,2.15,0,0,0,.036.567c.176.552.96.6,1.56.548.309-.565-.094-1.224-.36-1.807s-.248-1.478.4-1.625c.464-.1,1.005.277,1.4.017.181-.121.265-.352.46-.451.473-.24.872.456,1.381.612.7.214,1.235-.667,1.235-1.372s-.184-1.508.3-2.042c.153-.169.357-.288.524-.444a2.912,2.912,0,0,0,.691-1.908c.116-1.093,4.626,1.738,4.91,1.783,2.169.346,3.5-1.711,4.985-2.837a13.421,13.421,0,0,1,2.589-1.4c-6.173-18.994-22.8-33.911-43.05-38.485a20.023,20.023,0,0,0-2.76-.511c.279,1.322,1.133,3.409.206,4.663-1.178,1.594-3.671.2-4.588,2.068-.031.476.8.4,1.184.7a1.632,1.632,0,0,1,.373.7c.106.246.355.493.62.416.309.441-.172.984-.581,1.343a3.468,3.468,0,0,0-1.113,1.513c-.379,1.25.48,2.491,1.03,3.68a16.485,16.485,0,0,1,.965,3.086c.008-.5.744-.7,1.208-.471a5.246,5.246,0,0,1,1.123,1.024c.64.587,1.467.231,2.156.733.858.621,1.406,1.737,2.465,1.905,1.284.206,2.216-1.1,2.786-2.219,1.411.715,2.283,2.44,3.877,2.553a4.251,4.251,0,0,0,1.777-.392q1.753-.659,3.5-1.32a2.27,2.27,0,0,1,1.508-.2,2.13,2.13,0,0,1,1.1,1.333l.755,1.757a1.223,1.223,0,0,1,.14.758,1.137,1.137,0,0,1-.561.609,6.562,6.562,0,0,1-4.538.886,23.565,23.565,0,0,0,1.238,5.958c-1.193-.3-2.565.085-3.67-.355",
    transform: "translate(-192.7 -137.996)",
    fill: "#fff",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M264.846,239.37a2.4,2.4,0,0,1-1.793.88,11.691,11.691,0,0,1-1.262-.228,1.2,1.2,0,0,0-1.156.367c-.3.438-.015,1.014.267,1.462a1.768,1.768,0,0,0,.926.874,8.928,8.928,0,0,0,.971.052c.636.1,1.043.674,1.464,1.139s1.111.884,1.672.582c.369-.2.528-.645.886-.861.874-.527,1.949.619,2.741.187.938-.511.595-1.973.206-2.8a7.654,7.654,0,0,0-1.867-2.1C266,237.162,266.267,237.75,264.846,239.37Z",
    transform: "translate(-193.712 -167.897)",
    fill: "#fff",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M303.479,255.931c9.354-8.867,14.825-21.789,15.9-34.215.03-.346.056-.691.08-1.033-1.8-1.78-5.4-2.915-6.338.286-.371-.026-.447-.236-.729-.437-.443-.314-1.066.112-1.314.584-.816,1.546-.928,3.487-3.169,3.07-2.671-.5-.859-1.591-1.73-3a2.969,2.969,0,0,0-.522-.5,2.79,2.79,0,0,1-.425-2.477,1.052,1.052,0,0,0,1.4-.559,1.538,1.538,0,0,1,.206-.587c.3-.341.927-.022,1.072.4a12.332,12.332,0,0,1,.131,1.333c.1.438.6.868,1,.635a.78.78,0,0,0,.313-.46,2.353,2.353,0,0,0-.459-2.217.971.971,0,0,0-.044-1.905c-.65-.136-1.58.232-1.843-.354a1.385,1.385,0,0,1-.573,1.368c-1.725,1.2-5.6.131-5.217,3.645a12.885,12.885,0,0,1,.255,1.683,1.3,1.3,0,0,1-.922,1.3c1.047.808.664,2.659,1.789,3.365a1.478,1.478,0,0,0,1.745-.177.635.635,0,0,1,.246-.185c.2-.062.395.123.6.167.364.074.68-.287,1.052-.306.519-.028.8.566.894,1.056s.23,1.089.731,1.223c.171.045.355.023.526.069a.851.851,0,0,1,.57.791,2.393,2.393,0,0,1-.236.993c-.216.209-.6.081-.81-.134a5.762,5.762,0,0,0-.574-.684c-.135-.1-3.243.127-3.145-.089-.462,1.024-.7,3.264-2.3,2.693-.567-.2-1.145-.569-1.725-.4q.414-1.085.8-2.179c-.235-.2-.6.073-.7.358s-.116.63-.366.811a1.047,1.047,0,0,1-.636.124l-2.151-.041a2.679,2.679,0,0,0-2.158.6,1.818,1.818,0,0,0,.354,2.31c.141.152.307.319.292.522a.762.762,0,0,1-.309.449,3.006,3.006,0,0,0-1.056,2.606,2.071,2.071,0,0,0,2.094,1.719c.388-.033.87-.157,1.1.144.134.177.13.463.339.553.263.113.483-.2.671-.41a1.2,1.2,0,0,1,1.419-.22,5.335,5.335,0,0,1,.76,2.55c-.429.7-2.465.426-3.261.46a1.19,1.19,0,0,0-.854.264c-.315.347-.059.9.293,1.212s.813.556.988.984a1.829,1.829,0,0,1,.078.792,1.968,1.968,0,0,1-.514,1.5c-.2.164-.462.25-.663.414a1.518,1.518,0,0,0-.333,1.611c.16.557.473,1.071.584,1.639.237,1.209-.457,2.522.045,3.654.242.547,1,.984,1.472.6.408-.333.4-1.119.938-1.176.511-.055,1.145,1.178,1.569,1.417.336.19,1.013-.123,1.63.3C302.838,254.789,302.94,255.554,303.479,255.931Z",
    transform: "translate(-202.694 -160.882)",
    fill: "#fff",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M195.192,157.138c.526-.64.857-1.377,1.845-1.541,1.345-.225,1.854.5,1.265,1.717a.527.527,0,0,0-.079.344c.092.372.673.155,1-.059a2.781,2.781,0,0,1,2.581-.119,11.544,11.544,0,0,0,.369-3.853c-.672-1.419-3.782-.751-3.144-2.295,1.164-.024,2.356.121,3.525.2l.192-1.611c-.048.4,2.126.318,2.372.2.957-.465.7-2.131,2.414-1.86,2.173.343,2.3,4.428-.173,3.761a10.2,10.2,0,0,0-.88,3.957c-.447,0-.9-.008-1.344-.014a1.12,1.12,0,0,0-.165,1.039,3.488,3.488,0,0,0,3.709.034c.705.517,1.7.022,2.429-.47a2.861,2.861,0,0,0,4.684-.351c.752-1.7-1.117-3.853-3-3.461a4.021,4.021,0,0,0-.916-2.375,5.624,5.624,0,0,0,5.373-3.561c.377-1.064.462-2.353,1.4-3.029.416-.3.944-.428,1.38-.7a3.964,3.964,0,0,0,1.413-2.969q.15-1.121.221-2.247a60.254,60.254,0,0,0-35.242,18.748,2.163,2.163,0,0,0,.089,1.159,2.6,2.6,0,0,0,1.864,1.1c2.852.721,4.675.564,6.652-1.558C195.087,157.263,195.14,157.2,195.192,157.138Z",
    transform: "translate(-173.807 -137.871)",
    fill: "#fff",
    style: {
      isolation: "isolate"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "People",
    transform: "translate(33.298 53.799)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1495",
    "data-name": "Group 1495",
    transform: "translate(0 43.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1492",
    "data-name": "Group 1492",
    transform: "translate(2.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M50.234,129.711a8.271,8.271,0,0,0,4.363,7.221,9.033,9.033,0,0,0,9.716-.66,8.187,8.187,0,0,0,3.345-6.561,8.721,8.721,0,0,0-17.424,0Z",
    transform: "translate(-49.52 -120.695)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M8.206.056a8.18,8.18,0,0,1,8.263,7.924,7.907,7.907,0,0,1-8.15,7.811A8.18,8.18,0,0,1,.056,7.868,7.907,7.907,0,0,1,8.206.056Z",
    transform: "matrix(0.987, -0.16, 0.16, 0.987, 0, 2.518)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M55.465,130.419a1.3,1.3,0,0,0,1.008,1.164,1.722,1.722,0,0,0,.036,1.164c.246.64,1.589.64,1.589.64a.681.681,0,0,0,.611.394c.029.038.061.069.086.1.058.083.123.169.192.252.166,1.265.134,2.6-.513,3.276,0,0,.011.007.015.014-.564.059-1.131.131-1.69.218-.268.038-.535.083-.8.131a9.033,9.033,0,0,0,9.716-.66c-.249,0-.531-.007-.838-.007-.455,0-.968,0-1.528.014a.129.129,0,0,0-.014-.031,1.768,1.768,0,0,1-1.582-1.106,2.33,2.33,0,0,1-.1-.863,2.966,2.966,0,0,0,.722-.228,2.912,2.912,0,0,0,1.481-1.551,2.685,2.685,0,0,0,.1-.29,6.987,6.987,0,0,0,.188-2.481,1.173,1.173,0,0,0,.592-.8.861.861,0,0,0-.618-1.047,1.135,1.135,0,0,0,.9-1.168.91.91,0,0,0-.9-1.033s.318-.439-.3-1.255a1.127,1.127,0,0,0-1.469-.314,1.733,1.733,0,0,0-1.709-.74,1.849,1.849,0,0,0-1.333.84s0-.6-1.207-.266a1.548,1.548,0,0,0-1.058,1.662.905.905,0,0,0-1.228.439c-.419.833.488,2.291.488,2.291A1.144,1.144,0,0,0,55.465,130.419Z",
    transform: "translate(-50.923 -121.535)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M50.234,129.711a8.271,8.271,0,0,0,4.363,7.221,9.033,9.033,0,0,0,9.716-.66,8.187,8.187,0,0,0,3.345-6.561,8.721,8.721,0,0,0-17.424,0Z",
    transform: "translate(-49.52 -120.695)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1493",
    "data-name": "Group 1493",
    transform: "translate(0 147.973)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 7.744,
    cy: 7.408,
    rx: 7.744,
    ry: 7.408,
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M60.734,339.479A6.767,6.767,0,0,1,59.2,343.76a7.425,7.425,0,0,1-5.773,2.7,7.5,7.5,0,0,1-4.112-1.213,6.9,6.9,0,0,1-3.188-5.77,7.309,7.309,0,0,1,14.6,0Z",
    transform: "translate(-45.686 -332.07)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M59.874,344.567a7.425,7.425,0,0,1-5.773,2.7,7.5,7.5,0,0,1-4.112-1.213c.244-.531.4-.847.4-.847a21.976,21.976,0,0,1,2.78-.654,2.2,2.2,0,0,1,.957-.455,2.566,2.566,0,0,0-.055-1.591,2.835,2.835,0,0,1-.745-.7,2.045,2.045,0,0,1-.395-.372,3.312,3.312,0,0,1-1.859-3.216,2.865,2.865,0,0,1,.007-.3c-.482-.046-.983.1-.636,1.035a2.668,2.668,0,0,1-.029,2.463,6.027,6.027,0,0,0-.055-1.068c0,1.671-.944,1.778-.944,1.778s.6-.6-.286-2.46-.629-4.376,1.056-4.484a2.245,2.245,0,0,1,1.866.749,2.925,2.925,0,0,1,3.31-.369s1.516-.353,1.943.027c.093.083.022.274-.161.525a1.891,1.891,0,0,1,.848,1.2,2.764,2.764,0,0,1-.414,2.27c.2,1.837-.125,3.212-1.65,3.341,0,.046-.007.092-.01.136,0,.064-.006.129-.006.187a2.108,2.108,0,0,0,.106.784,4.333,4.333,0,0,1,.639.166c1.368,0,2.9.138,2.9.138l.016.009A2.038,2.038,0,0,1,59.874,344.567Z",
    transform: "translate(-46.357 -332.877)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 7.744,
    cy: 7.408,
    rx: 7.744,
    ry: 7.408,
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1494",
    "data-name": "Group 1494",
    transform: "translate(279.293 85.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M8.362.186A8.824,8.824,0,0,1,16.91,8.733,7.928,7.928,0,0,1,8.733,16.91,8.824,8.824,0,0,1,.186,8.362,7.928,7.928,0,0,1,8.362.186Z",
    transform: "translate(0 11.563) rotate(-45)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M448.989,256.455a7.433,7.433,0,0,1-1.35,4.272,8.143,8.143,0,0,1-6.709,3.44,8.237,8.237,0,0,1-4.936-1.62,7.578,7.578,0,0,1-3.122-6.092,8.067,8.067,0,0,1,16.117,0Z",
    transform: "translate(-428.843 -244.893)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M448.772,261.413a8.143,8.143,0,0,1-6.709,3.44,8.237,8.237,0,0,1-4.937-1.62,4.132,4.132,0,0,1,.047-1.264c.1-.942,1.236-1.7,1.215-2.363s-1.166-1.512-.425-1.892.9-1.847.305-2.671a1.739,1.739,0,0,1,.046-2.5,3.456,3.456,0,0,1,2.2-1.143,4.21,4.21,0,0,1,2.385-.329,5.2,5.2,0,0,1,2.371.77,3.337,3.337,0,0,1,1.233,1.455,4.426,4.426,0,0,1,.255,3.339c-.4,1.1,1.389,1.037,1.439,2.051s-.84,1.068-.684,1.746C447.581,260.738,448.2,261.03,448.772,261.413Z",
    transform: "translate(-429.976 -245.578)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M8.362.186A8.824,8.824,0,0,1,16.91,8.733,7.928,7.928,0,0,1,8.733,16.91,8.824,8.824,0,0,1,.186,8.362,7.928,7.928,0,0,1,8.362.186Z",
    transform: "translate(0 11.563) rotate(-45)",
    fill: "#fff",
    opacity: 0.7
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1500",
    "data-name": "Group 1500",
    transform: "translate(35.46 10.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M0,0,70.625,1.127l.012.7L.012.7Z",
    transform: "matrix(0.917, -0.398, 0.398, 0.917, 153.671, 75.821)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M0,0,.723.014,1.753,51.35l-.723-.014Z",
    transform: "matrix(0.85, -0.526, 0.526, 0.85, 63.354, 13.33)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M0,0,73.806.644l.006.7L.006.7Z",
    transform: "translate(0.315 142.232) rotate(-11.833)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M0,0,70.625,1.127l.012.7L.012.7Z",
    transform: "matrix(0.917, -0.398, 0.398, 0.917, 153.671, 75.821)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M0,0,.723.014,2.255,76l-.723-.014Z",
    transform: "matrix(0.847, -0.531, 0.531, 0.847, 161.869, 117.02)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M0,0,.723.014,2.255,76l-.723-.014Z",
    transform: "matrix(0.847, -0.531, 0.531, 0.847, 161.869, 117.02)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M0,0,.723.014,1.753,51.35l-.723-.014Z",
    transform: "matrix(0.85, -0.526, 0.526, 0.85, 63.354, 13.33)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_641",
    "data-name": "Path 641",
    d: "M0,0,73.806.644l.006.7L.006.7Z",
    transform: "translate(0.315 142.232) rotate(-11.833)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M164.861,279.9,94,216.177l10.02-72.479.075-.08L157.486,86.3l.134-.017,96.751-12.8,59.08,48.938-.021.183L298.158,254.188l-.262.05ZM94.779,215.913l70.308,63.226L297.49,253.6l15.191-130.894L254.142,74.22,157.853,86.957,104.72,144Z",
    transform: "translate(-94.004 -73.483)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M164.861,279.9,94,216.177l10.02-72.479.075-.08L157.486,86.3l.134-.017,96.751-12.8,59.08,48.938-.021.183L298.158,254.188l-.262.05ZM94.779,215.913l70.308,63.226L297.49,253.6l15.191-130.894L254.142,74.22,157.853,86.957,104.72,144Z",
    transform: "translate(-94.004 -73.483)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1496",
    "data-name": "Group 1496",
    transform: "translate(88.384 53.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M219.876,153.881l-1.1,6.127-1.1-6.127Z",
    transform: "translate(-215.603 -150.843)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M221.192,152.577a3.179,3.179,0,1,1-3.176-3.038A3.109,3.109,0,0,1,221.192,152.577Z",
    transform: "translate(-214.84 -149.539)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M218.622,150.69c.354.444.075,1.216-.623,1.725s-1.55.56-1.9.116-.075-1.216.623-1.724S218.269,150.246,218.622,150.69Z",
    transform: "translate(-215.136 -149.794)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1497",
    "data-name": "Group 1497",
    transform: "translate(150.642 73.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M304.993,182.31l-1.1,6.127-1.1-6.127Z",
    transform: "translate(-300.72 -179.272)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 3.176,
    cy: 3.038,
    rx: 3.176,
    ry: 3.038,
    transform: "translate(0)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M303.739,179.119c.353.444.075,1.215-.623,1.724s-1.55.56-1.9.116-.075-1.215.623-1.724S303.386,178.675,303.739,179.119Z",
    transform: "translate(-300.253 -178.223)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1498",
    "data-name": "Group 1498",
    transform: "translate(69.587 124.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M194.177,256.022l-1.1,6.127-1.1-6.127Z",
    transform: "translate(-189.904 -252.984)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 3.176,
    cy: 3.038,
    rx: 3.176,
    ry: 3.038,
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M192.924,252.831c.353.444.074,1.216-.624,1.725s-1.55.56-1.9.116-.074-1.216.624-1.724S192.57,252.387,192.924,252.831Z",
    transform: "translate(-189.437 -251.935)",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1499",
    "data-name": "Group 1499",
    transform: "translate(159.004 113.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M316.424,240.466l-1.1,6.127-1.1-6.127Z",
    transform: "translate(-312.151 -237.428)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M317.74,239.162a3.179,3.179,0,1,1-3.176-3.038A3.109,3.109,0,0,1,317.74,239.162Z",
    transform: "translate(-311.388 -236.124)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M315.17,237.275c.353.444.075,1.215-.623,1.724s-1.55.56-1.9.116-.075-1.216.623-1.724S314.817,236.831,315.17,237.275Z",
    transform: "translate(-311.684 -236.379)",
    fill: "#fff",
    opacity: 0.3
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1509",
    "data-name": "Group 1509",
    transform: "translate(221.216 29.472)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M409.172,135.7a22.591,22.591,0,0,1-4.864,13.984,22.957,22.957,0,0,1-3.714,3.764,23.19,23.19,0,0,1-4.027,2.673,25.351,25.351,0,0,1-21.863.809c-.285-.114-.57-.246-.846-.387l-.009-.009a23.953,23.953,0,0,1-10.233-9.26A22.375,22.375,0,0,1,360.4,135.7c0-12.884,10.923-23.332,24.391-23.332S409.172,122.818,409.172,135.7Z",
    transform: "translate(-351.302 -103.67)",
    fill: "#ff725e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_642",
    "data-name": "Path 642",
    d: "M23.163.514A24.444,24.444,0,0,1,46.841,24.191,21.96,21.96,0,0,1,24.191,46.841,24.444,24.444,0,0,1,.514,23.163,21.96,21.96,0,0,1,23.163.514Z",
    transform: "translate(0 32.031) rotate(-45)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1508",
    "data-name": "Group 1508",
    transform: "translate(12.93 13.115)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M370.639,153.6l2.285-9.078s1.449-1.1,1.54-1.908-.892-5.559-1.521-5.846-4.344.952-4.526,1.967,1.285,5.009,1.579,5.335l-3.752,10.56Z",
    transform: "translate(-365.802 -124.101)",
    fill: "#e4897b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M372.309,152.819l-1.375,11.928a22.655,22.655,0,0,1-5.293-6.07c.848-2.86,1.7-5.431,2.107-6.583.134-.41.214-.64.214-.64l.785.094,3.259.393.4.051Z",
    transform: "translate(-365.64 -128.523)",
    fill: "#ff725e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M380.473,162.072l-2.124,7.548c-.277-.111-.554-.239-.821-.376l-.009-.008a22.78,22.78,0,0,1-4.642-2.92c.17-.367,4.517-9.751,6.141-9.64Z",
    transform: "translate(-367.584 -130.091)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M372.309,152.819l-1.375,11.928a22.655,22.655,0,0,1-5.293-6.07c.848-2.86,1.7-5.431,2.107-6.583.134-.41.214-.64.214-.64l.785.094,3.259.393.4.051Z",
    transform: "translate(-365.64 -128.523)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M380.473,162.072l-2.124,7.548c-.277-.111-.554-.239-.821-.376l-.009-.008a22.78,22.78,0,0,1-4.642-2.92c.17-.367,4.517-9.751,6.141-9.64Z",
    transform: "translate(-367.584 -130.091)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M373.97,151.106l-.749,1.607-5.191-.826.118-.915Z",
    transform: "translate(-366.282 -128.379)",
    fill: "#ff725e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M405.064,133.278c-.606,2.22,2.706,8.343,1.363,19.481s-14.112,10.459-19.851,6.746-4.746-23.863-2.772-27.837S405.064,133.278,405.064,133.278Z",
    transform: "translate(-370.103 -122.153)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1501",
    "data-name": "Group 1501",
    transform: "translate(9.935 26.173)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M407.63,159.052c-.126.325-.233.641-.349.965s-.232.632-.339.94c-.214.615-.42,1.213-.625,1.793-.41,1.161-.776,2.271-1.124,3.312a22.469,22.469,0,0,1-3.91,2.6,24.6,24.6,0,0,1-21.226.786c-.277-.111-.554-.239-.821-.376.009-.222.009-.453.009-.666s0-.435.01-.649c.009-.64.036-1.238.053-1.8.018-.376.036-.743.045-1.085.009-.179.018-.341.026-.512.036-.623.063-1.187.108-1.716.009-.171.027-.341.036-.5.035-.5.08-.94.116-1.349a11.52,11.52,0,0,1,.857-4.022.906.906,0,0,1,.125-.179c.071-.077.107-.085.107-.085s.357-.034.955-.077c1.58-.128,4.856-.351,7.819-.333a1.143,1.143,0,0,1,.17.008q.589.013,1.178.051c1.527.077,3.052.205,4.561.385.563.068,1.124.145,1.687.222q.911.128,1.821.281c.08.017.17.026.25.043a62.9,62.9,0,0,1,6.641,1.451c.607.162,1.214.333,1.812.521Z",
    transform: "translate(-379.226 -156.089)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M407.617,159.052c0,.009,0,.009-.009.017-.116.316-.232.632-.331.947-.124.316-.232.632-.339.94-.214.615-.42,1.213-.625,1.793-.41,1.161-.776,2.271-1.124,3.312a22.467,22.467,0,0,1-3.91,2.6,24.6,24.6,0,0,1-21.226.786c-.277-.111-.554-.239-.821-.376l-.009-.008c0-.222.009-.444.018-.658s0-.435.01-.649c.009-.64.036-1.238.053-1.8.018-.376.036-.743.045-1.085.009-.179.018-.341.026-.512.027-.623.063-1.187.108-1.716.009-.171.027-.341.036-.5.035-.5.08-.94.116-1.349a11.519,11.519,0,0,1,.857-4.022.907.907,0,0,1,.125-.179c.071-.077.107-.085.107-.085s.357-.034.955-.077c1.58-.128,4.856-.351,7.819-.333a1.142,1.142,0,0,1,.17.008q.589.013,1.178.051c1.527.077,3.052.205,4.561.385.563.068,1.124.145,1.687.222q.911.128,1.821.281c.08.017.17.026.25.043a62.9,62.9,0,0,1,6.641,1.451C406.412,158.694,407.018,158.865,407.617,159.052Z",
    transform: "translate(-379.223 -156.089)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M396.807,155.212c5.224.392,5.865,1.9,5.307,2.693s-7.634,7.408-9.764,11.84C392.35,169.745,384.679,154.3,396.807,155.212Z",
    transform: "translate(-372.171 -129.641)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M394.994,157.773c5.171-.633,6.724-2.746,6.724-2.746-3.28-2.961-.555-8.092-.555-8.092l-6.223,1.112a16.755,16.755,0,0,1,.243,2.506c.048,3.613-1.661,3.649-1.661,3.649C392.43,156.16,394.994,157.773,394.994,157.773Z",
    transform: "translate(-373.055 -127.167)",
    fill: "#e4897b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M395.56,148.048a16.754,16.754,0,0,1,.243,2.506,6.909,6.909,0,0,0,5.98-3.618Z",
    transform: "translate(-373.675 -127.167)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1506",
    "data-name": "Group 1506",
    transform: "translate(13.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1505",
    "data-name": "Group 1505",
    transform: "translate(4.058 2.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M397.232,124.724c-5.41-.283-7.31,2.4-8.011,7.708-.877,6.639.4,11.454,7.243,10.385C405.76,141.366,406.217,125.2,397.232,124.724Z",
    transform: "translate(-388.976 -122.717)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M393.491,135.6a11.041,11.041,0,0,1-1.7,2.064,1.5,1.5,0,0,0,1.393.66Z",
    transform: "translate(-389.732 -125.989)",
    fill: "#de5753"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1502",
    "data-name": "Group 1502",
    transform: "translate(6.879 8.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M398.673,134.929c-.034.424.177.786.473.809s.564-.3.6-.729-.177-.786-.473-.809S398.708,134.5,398.673,134.929Z",
    transform: "translate(-398.458 -133.795)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M399.315,134.056l-.935-.434S398.8,134.435,399.315,134.056Z",
    transform: "translate(-398.38 -133.622)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1503",
    "data-name": "Group 1503",
    transform: "translate(1.368 7.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M391.14,134.212c-.035.425.177.786.473.809s.564-.3.6-.728-.177-.787-.473-.809S391.174,133.787,391.14,134.212Z",
    transform: "translate(-390.924 -133.078)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M391.782,133.34l-.936-.435S391.263,133.718,391.782,133.34Z",
    transform: "translate(-390.846 -132.905)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M401.238,131.179a.255.255,0,0,1-.2-.1,2.648,2.648,0,0,0-2.08-.807.24.24,0,1,1-.037-.479,3.132,3.132,0,0,1,2.523,1,.234.234,0,0,1-.056.336A.262.262,0,0,1,401.238,131.179Z",
    transform: "translate(-391.583 -124.244)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M390.6,129.935a.254.254,0,0,1-.217-.119.234.234,0,0,1,.089-.328,2.884,2.884,0,0,1,2.408-.326.236.236,0,0,1,.13.316.256.256,0,0,1-.328.125,2.373,2.373,0,0,0-1.955.3A.257.257,0,0,1,390.6,129.935Z",
    transform: "translate(-389.343 -124.018)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1504",
    "data-name": "Group 1504",
    transform: "translate(4.126 13.628)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M394.617,142.125a12.722,12.722,0,0,1,.528,1.83c.117,0,.233,0,.35-.013,1.583-.069,2.294-.6,2.6-1.172a1.889,1.889,0,0,0,.208-.9,1.8,1.8,0,0,0-.071-.525,7.741,7.741,0,0,1-3.077.751C394.826,142.122,394.617,142.125,394.617,142.125Z",
    transform: "translate(-394.617 -141.341)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M395.354,142.092l.17.536a4.868,4.868,0,0,0,2.978-.763,1.8,1.8,0,0,0-.071-.525A7.741,7.741,0,0,1,395.354,142.092Z",
    transform: "translate(-394.815 -141.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M395.818,144.555c1.583-.069,2.294-.6,2.6-1.172a5.309,5.309,0,0,0-1.742.411A1.877,1.877,0,0,0,395.818,144.555Z",
    transform: "translate(-394.94 -141.954)",
    fill: "#de5753"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M402.771,132.9s-2.286-4.384-1.715-7.647c0,0-10.481-4.752-11.606,5.63,0,0-.518-9.3,8.793-9.017s8.527,13.295,3.5,16.92C401.746,138.791,404.184,135.645,402.771,132.9Z",
    transform: "translate(-389.102 -121.864)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M406.352,138.291a2.356,2.356,0,0,1,2.674-1.94c1.666.262,2.277,3.6-1.938,4.17C406.483,140.6,406.177,140.025,406.352,138.291Z",
    transform: "translate(-393.629 -126.205)",
    fill: "#e4897b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M398,123.784a18.943,18.943,0,0,0,3.155,12.181,6.72,6.72,0,0,1-.453,8.249s5.4-3.29,5.59-8.249c0,0,4.464-11.859-4.8-15.056,0,0-.038-2.671-6.078-2.163s-10.906,5.46-11.829,11.772S386.1,143.87,386.1,143.87,382.444,121.5,398,123.784Z",
    transform: "translate(-383.427 -118.681)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M403.434,126.034a14.322,14.322,0,0,0-.449,4.588,21.8,21.8,0,0,0,.778,4.63,19.109,19.109,0,0,0,1.81,4.372,12.741,12.741,0,0,0,3.061,3.679,12.888,12.888,0,0,1-3.219-3.591,19.436,19.436,0,0,1-2-4.363,22.252,22.252,0,0,1-.973-4.692,14.755,14.755,0,0,1,.3-4.834Z",
    transform: "translate(-388.514 -120.826)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1507",
    "data-name": "Group 1507",
    transform: "translate(31.992 29.137)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M416.894,163.68a23.9,23.9,0,0,1-7.516,6.25c.08-.3.187-.6.294-.9a22.928,22.928,0,0,1,3.9-6.4,26.316,26.316,0,0,1,2.134-2.3l.018-.017C416.286,160.768,416.653,161.989,416.894,163.68Z",
    transform: "translate(-409.378 -160.324)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M416.894,163.68a23.9,23.9,0,0,1-7.516,6.25c.08-.3.187-.6.294-.9a22.928,22.928,0,0,1,3.9-6.4,26.316,26.316,0,0,1,2.134-2.3l.018-.017C416.286,160.768,416.653,161.989,416.894,163.68Z",
    transform: "translate(-409.378 -160.324)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1510",
    "data-name": "Group 1510",
    transform: "translate(181.672)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 13.309,
    cy: 12.731,
    rx: 13.309,
    ry: 12.731,
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M320.037,70.859a11.679,11.679,0,0,1-3.355,8.166,12.925,12.925,0,0,1-18.865-.518,11.6,11.6,0,0,1-2.88-7.648,12.563,12.563,0,0,1,25.1,0Z",
    transform: "translate(-294.178 -58.125)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M317.739,79.614a12.925,12.925,0,0,1-18.865-.518,1.443,1.443,0,0,1,.2-.063,2.719,2.719,0,0,1,.6-.6.687.687,0,0,1,.005-.1l.221-.037a2.723,2.723,0,0,1,1.374-.344,3.782,3.782,0,0,1,.409.021l.783-.137s-.006.074-.017.206c.993.074,2.505.164,4.227.275a2.14,2.14,0,0,0,.778-1.05,3.574,3.574,0,0,0,.149-1.383,4.506,4.506,0,0,1-1.755-.444,4.369,4.369,0,0,1-2.168-2.359,3.874,3.874,0,0,1-.138-.432,10.407,10.407,0,0,1-.067-4.535V68.1a1.046,1.046,0,0,1-.132,0,.129.129,0,0,1-.11-.132c0-.01.006-.022.006-.031a.146.146,0,0,1,.165-.117c.012,0,.022,0,.039,0a8.821,8.821,0,0,1,.21-2.713,3.1,3.1,0,0,1-.022-2.739c.469-.644.1-.3,1.335-.4s.486-1.145,1.269-1.156.624.459,1.584.807.607-.7,1.7-.8,1.247.7,2.03.9a3.9,3.9,0,0,0,1.512,0c.574,0,.624,1.594.866,1.889s.646-.148,1.164.671a.719.719,0,0,1,.094.39c0,1.056-1.379,3.067-1.379,3.067a14.427,14.427,0,0,1-.282,1.488,1.326,1.326,0,0,1,.248,1.583,3.014,3.014,0,0,1-1.213,1.241,8.514,8.514,0,0,1-.789,1.32c-.347,1.832-.513,4,.138,5.363A43.458,43.458,0,0,1,317.739,79.614Z",
    transform: "translate(-295.235 -58.714)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 13.309,
    cy: 12.731,
    rx: 13.309,
    ry: 12.731,
    fill: "#fff",
    opacity: 0.5
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1511",
    "data-name": "Group 1511",
    transform: "translate(87.608 197.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_643",
    "data-name": "Path 643",
    d: "M13.02.289A13.74,13.74,0,0,1,26.33,13.6,12.344,12.344,0,0,1,13.6,26.33,13.74,13.74,0,0,1,.289,13.02,12.344,12.344,0,0,1,13.02.289Z",
    transform: "translate(0 18.005) rotate(-45)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M198.977,361.211a11.709,11.709,0,0,1-3.929,8.715,12.985,12.985,0,0,1-15.726,1.182,11.857,11.857,0,0,1-5.446-9.9,12.563,12.563,0,0,1,25.1,0Z",
    transform: "translate(-167.601 -343.207)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M197.047,370.88a12.985,12.985,0,0,1-15.726,1.182c.911-.121,1.87-.232,2.847-.327.756-1.573.563-4.074.16-6.191a10.193,10.193,0,0,1-.9-1.526,3.407,3.407,0,0,1-1.4-1.43,1.533,1.533,0,0,1,.282-1.832,13.509,13.509,0,0,1-.409-2.887l-.055.026A4.219,4.219,0,0,1,184.6,352.8c3.775-1.366,7.587,1.077,7.587,1.077s.817-1.457,1.793-1.077c.828.323.386,1.357.232,1.674a1.982,1.982,0,0,1,.855-.713c.668-.29,1.589.523-.48,2.5a3.022,3.022,0,0,1-.739.507,9.322,9.322,0,0,1,.056,2.7,11.958,11.958,0,0,1-.078,5.231,3.493,3.493,0,0,1-.16.5,4.988,4.988,0,0,1-2.505,2.723,5.082,5.082,0,0,1-2.025.518,4.214,4.214,0,0,0,.17,1.594,2.51,2.51,0,0,0,.9,1.214c1.992-.132,3.735-.227,4.883-.317-.011-.158-.022-.237-.022-.237l.906.158A3.979,3.979,0,0,1,197.047,370.88Z",
    transform: "translate(-169.601 -344.161)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_644",
    "data-name": "Path 644",
    d: "M13.02.289A13.74,13.74,0,0,1,26.33,13.6,12.344,12.344,0,0,1,13.6,26.33,13.74,13.74,0,0,1,.289,13.02,12.344,12.344,0,0,1,13.02.289Z",
    transform: "translate(0 18.005) rotate(-45)",
    fill: "#fff",
    opacity: 0.5
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1512",
    "data-name": "Group 1512",
    transform: "translate(29.817 66.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_645",
    "data-name": "Path 645",
    d: "M12.762.129C19.81.2,25.582,6.2,25.653,13.537A12.72,12.72,0,0,1,13.02,26.687C5.972,26.615.2,20.613.129,13.279A12.72,12.72,0,0,1,12.762.129Z",
    transform: "translate(0 24.782) rotate(-76.717)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_515",
    "data-name": "Path 515",
    d: "M116.124,168.9a11.677,11.677,0,0,1-3.19,8,12.966,12.966,0,0,1-16.752,1.711,11.844,11.844,0,0,1-5.16-9.707,12.563,12.563,0,0,1,25.1,0Z",
    transform: "translate(-87.56 -153.585)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_516",
    "data-name": "Path 516",
    d: "M114.086,178.1a12.966,12.966,0,0,1-16.752,1.711l4.977-1.468c.094.1.182.211.276.327.209-.037.425-.079.64-.116.4-.069.794-.121,1.2-.179a3.453,3.453,0,0,0,.5-1.473c-.419.021-.685.026-.685.026.138-.474-.6-1.462-.6-1.462l-.248,1.3a2.8,2.8,0,0,1-.839-.28c-.331-.2-.767-1.62-.767-1.62s-.861,1.383-1.049,1.7-.69,0-.69,0a4.631,4.631,0,0,1,.083-2.433c.42-1.241-.877-1.2-.877-1.2a4.122,4.122,0,0,1-.331,1.362,4.024,4.024,0,0,0-.336,1.779c0,.5.044.855-.331.855s-.419-.316-.38-.855-.541-1.061-.2-1.5.083-1.641.083-1.641c-.21.839-1.17.8-1.336,1.4s.458,1.441.165,1.742-.794,0-.794,0,.42-.66.127-1.045-.756-.576-.546-1.357.584-.776.464-1.641-.546-.813,0-1.135a4.2,4.2,0,0,0,1.252-2.5c0-.659-.293-2.175.877-2.707s1.462-.945,1.253-2.354.916-1.309,2.34-1.029c0,0,.706-1.077,1.374-.876s1.17.079,1.313-.28,1.987-.322,2.262,0a2.082,2.082,0,0,0,1.871.316c.6-.237,2.2.718,2.152,1.357s-.039,1,.822,1.367,1.021.554,1.4,1.985-.249,2.005.5,2.559.668,2.761.712,3.442,0,1.436,0,1.436l-.209.058c-.21.052-.375-.739-.337-1.325.045-.559-1.269-1.378-1.379-1.446.027.058.265.544.419.929a6.708,6.708,0,0,1,.165,2.143c-.039.681.794,1.056.794,1.056l-.916.438a4.157,4.157,0,0,1-.469-2.206,1.569,1.569,0,0,0-.453-1.431v1.431s-.248.511-.623,1.192.293.882.4,1.241-.822.38-.822.38l-.171-.86-.315.86a5.064,5.064,0,0,1-1.81.528,2.9,2.9,0,0,0,.364,1.367c.3-.016.6-.032.894-.043.59,0,1.2.006,1.793.027h.011C112.348,177.98,113.346,178.043,114.086,178.1Z",
    transform: "translate(-88.712 -154.784)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_646",
    "data-name": "Path 646",
    d: "M12.762.129C19.81.2,25.582,6.2,25.653,13.537A12.72,12.72,0,0,1,13.02,26.687C5.972,26.615.2,20.613.129,13.279A12.72,12.72,0,0,1,12.762.129Z",
    transform: "translate(0 24.782) rotate(-76.717)",
    fill: "#fff",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1517",
    "data-name": "Group 1517",
    transform: "translate(75.891 1.706)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 22.325,
    cy: 21.355,
    rx: 22.325,
    ry: 21.355,
    transform: "translate(0)",
    fill: "#ff725e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_517",
    "data-name": "Path 517",
    d: "M193.466,81.91A19.976,19.976,0,0,1,188.975,94.5a20.469,20.469,0,0,1-2.567,2.673,20.121,20.121,0,0,1-2.772,2.043.344.344,0,0,1-.124.077,20.026,20.026,0,0,1-2.4,1.287,22.3,22.3,0,0,1-9.238,1.987,21.965,21.965,0,0,1-16.435-7.27l-.007-.007a20.023,20.023,0,0,1-5.157-13.378c0-11.391,9.692-20.655,21.6-20.655S193.466,70.519,193.466,81.91Z",
    transform: "translate(-149.546 -60.554)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(5.365 4.574)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M186.273,90.528c.476-1.011.814-.572,2.188.442a3.292,3.292,0,0,1,1.592,3.007c0,1.076-.217,3.221-.217,3.221l3.569,3.829-1.616,2.33-4.147-4.475s-2.049-1.476-2.387-3.137S186.273,90.528,186.273,90.528Z",
    transform: "translate(-164.291 -73.747)",
    fill: "#ebb376"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1513",
    "data-name": "Group 1513",
    transform: "translate(18.432 15.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M184.892,89.132l2.923,5.02a.6.6,0,0,1-.076.7l-2.267,2.5a.661.661,0,0,1-1.038-.083l-2.62-4.131Z",
    transform: "translate(-181.813 -89.132)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M184.877,89.9l2.58,4.65L185,97.322l-2.642-4.106Z",
    transform: "translate(-181.96 -89.364)",
    fill: "#ff725e",
    opacity: 0.4
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M194.958,113.051c.021.1.036.2.05.3-.059-.07-.117-.147-.175-.224a20.026,20.026,0,0,1-2.4,1.287c.191-1.42.4-2.7.592-3.771.168-.98.322-1.784.44-2.351s.183-.9.2-.952v-.007a2.935,2.935,0,0,1,.768.238,9.275,9.275,0,0,1,3.3,3.435A20.121,20.121,0,0,1,194.958,113.051Z",
    transform: "translate(-166.234 -78.967)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1514",
    "data-name": "Group 1514",
    transform: "translate(0 28.281)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M185.582,113.316c-.059-.07-.117-.147-.175-.224a20.026,20.026,0,0,1-2.4,1.287,22.3,22.3,0,0,1-9.238,1.987,21.965,21.965,0,0,1-16.435-7.27c.374-.084.753-.161,1.134-.231l.116-.021.227-.042c.987-.182,2-.343,3.007-.483a.025.025,0,0,1,.021-.007c.44-.063.885-.119,1.324-.175.585-.077,1.171-.14,1.749-.2a.926.926,0,0,1,.139-.014c1.339-.147,2.676-.266,3.979-.357.431-.028.855-.056,1.272-.077h.008c.549-.035,1.089-.07,1.623-.1s1.068-.049,1.58-.07l.637-.021c.636-.021,1.25-.035,1.835-.049,1.924-.042,3.613-.042,4.959-.028.315.007.614.007.892.014.5.007.936.021,1.288.035.717.014,1.111.035,1.111.035.088.308.176.63.257.959v.007c.372,1.434.717,3.03,1.039,4.744C185.553,113.12,185.568,113.218,185.582,113.316Z",
    transform: "translate(-156.807 -107.211)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M185.389,113.315c-.059-.07-.117-.147-.175-.224a20.023,20.023,0,0,1-2.4,1.287,22.3,22.3,0,0,1-9.238,1.987,21.965,21.965,0,0,1-16.435-7.27l-.527.1c.169-.035.344-.077.52-.112.38-.077.76-.154,1.141-.224l.116-.021.227-.042c.987-.182,2-.343,3.007-.483a.025.025,0,0,1,.021-.007c.44-.063.885-.119,1.324-.175.585-.077,1.171-.14,1.749-.2a.927.927,0,0,1,.139-.014c1.339-.147,2.676-.266,3.979-.357l1.265-.084c.556-.035,1.1-.063,1.638-.091s1.068-.049,1.58-.07l.637-.021c.628-.021,1.243-.042,1.829-.056,1.931-.035,3.62-.035,4.966-.028.322.007.614.007.892.014.5.007.922.021,1.273.028.723.021,1.126.042,1.126.042v.007c.088.308.176.63.257.959v.007c.372,1.434.717,3.03,1.039,4.744C185.36,113.119,185.374,113.217,185.389,113.315Z",
    transform: "translate(-156.614 -107.21)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M167.648,103.062c2.375,2.064,8.193,1.3,8.193,1.3s3.631-.951,2.869-2.036c-2.139-.339-3.174-1.293-3.6-2.515a5.7,5.7,0,0,1-.217-2.336,11.922,11.922,0,0,1,.18-1.3l-7.192-5.1C168.82,94.438,169.973,100.624,167.648,103.062Z",
    transform: "translate(-159.577 -74.083)",
    fill: "#ebb376"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M170.234,95.7c.285,4.127,3.831,5.266,5.568,5.5a5.7,5.7,0,0,1-.217-2.336Z",
    transform: "translate(-160.272 -75.474)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1516",
    "data-name": "Group 1516",
    transform: "translate(5.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M184.958,76.8s1.021,6.425-2.544,8.9-3.565-9.49-3.565-9.49Z",
    transform: "translate(-167.788 -69.618)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M169.053,90.323a6.248,6.248,0,0,0,7,2.26,6.737,6.737,0,0,0,3.875-3.019,6.378,6.378,0,0,0,.322-.616c1.755-3.927,2.313-10.795-2.028-13.369a6.778,6.778,0,0,0-9.1,1.981,6.1,6.1,0,0,0-.993,2.781C167.6,84.932,167.056,87.606,169.053,90.323Z",
    transform: "translate(-164.776 -69.138)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M177.865,86.05a.572.572,0,0,0,.34.744c.257.041.511-.229.579-.6s-.089-.7-.34-.744S177.934,85.675,177.865,86.05Z",
    transform: "translate(-167.516 -72.394)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M183.854,87.072a.576.576,0,0,0,.34.744c.251.041.511-.229.579-.6s-.089-.7-.34-.745S183.918,86.721,183.854,87.072Z",
    transform: "translate(-169.125 -72.701)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M181.681,87.266a13.028,13.028,0,0,0,1.285,3.474,2.369,2.369,0,0,1-1.921.028Z",
    transform: "translate(-168.377 -72.939)",
    fill: "#d58745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M176.29,83.622a.249.249,0,0,0,.236-.049,1.915,1.915,0,0,1,1.586-.491.23.23,0,0,0,.278-.16.22.22,0,0,0-.168-.266h0a2.357,2.357,0,0,0-2.009.594.213.213,0,0,0-.02.31l0,0A.364.364,0,0,0,176.29,83.622Z",
    transform: "translate(-167.059 -71.544)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M186.266,84.956a.234.234,0,0,0,.132.031.218.218,0,0,0,.16-.269v0a2.228,2.228,0,0,0-1.42-1.491.231.231,0,0,0-.286.147h0a.224.224,0,0,0,.154.274h0a1.806,1.806,0,0,1,1.105,1.2A.234.234,0,0,0,186.266,84.956Z",
    transform: "translate(-169.397 -71.722)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M172.077,75.5v2.051a1.509,1.509,0,0,0-1.034,1.8c.465,1.779-.879,4.3-2.376,5.19,0,0,.052-.742-.62-.642s-.982,3.954.052,5.93c0,0-1.7-1.878-2.273-6.03-.526-3.839-.255-6.956.729-8.3Z",
    transform: "translate(-164.219 -69.406)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M164.521,86.516a4.44,4.44,0,0,0,2.2,2.615c1.419.729,2.48-.406,2.384-1.864-.1-1.3-.941-3.275-2.512-3.389A1.982,1.982,0,0,0,164.521,86.516Z",
    transform: "translate(-163.914 -71.92)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M171.584,74.936s1.393,1.32,2.745.354c0,0,1.53,1.22,2.779.354a2.806,2.806,0,0,0,1.8,1.238.954.954,0,0,0,1.124-.973s1.77.973,2.424.518-.357-2.275-.357-2.275.832-.43.3-1.892-3.008-1.122-3.008-1.122a3.665,3.665,0,0,0-1.629-2.787,1.71,1.71,0,0,0-2.752.341s-1.671-2.161-3.74-1.877-1.832,1.649-1.832,1.649-2.378-1.422-3.448,0,0,2.1,0,2.1-2.378.764-2.259,2.316,1.339,1.324,1.339,1.324-.684.74.862,1.365,3-.91,3-.91a.988.988,0,0,0,.511,1.478C170.55,76.74,171.584,74.936,171.584,74.936Z",
    transform: "translate(-163.726 -66.79)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1515",
    "data-name": "Group 1515",
    transform: "translate(9.171 16.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M179.663,93.257a13.321,13.321,0,0,0-1.351,1.391c-.1-.054-.206-.107-.3-.166-1.371-.761-1.745-1.546-1.744-2.187a2.081,2.081,0,0,1,.568-1.329A7.373,7.373,0,0,0,179.2,92.99C179.479,93.162,179.663,93.257,179.663,93.257Z",
    transform: "translate(-176.264 -90.966)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M179.292,92.99l-.409.4c-1.29-.719-2.1-1.391-2.275-1.99a1.894,1.894,0,0,1,.316-.434A7.373,7.373,0,0,0,179.292,92.99Z",
    transform: "translate(-176.356 -90.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M178.008,95.052c-1.371-.761-1.745-1.546-1.744-2.187A5.048,5.048,0,0,1,177.612,94,1.782,1.782,0,0,1,178.008,95.052Z",
    transform: "translate(-176.264 -91.536)",
    fill: "#de5753"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_539",
    "data-name": "Path 539",
    d: "M173.449,107.585s-8.39-5.453-11.061-5.759-2.2,2.879-2.2,2.879-2.061,0-1.268,2.426,12.189,3.765,16.4,2.565,6.712-3.459,6.016-5.59-2.644-.306-2.644-.306-1.132-2.008-2.763-1.538S173.449,107.585,173.449,107.585Z",
    transform: "translate(-157.186 -77.306)",
    fill: "#ff725e"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M199.548,106.347a20.469,20.469,0,0,1-2.567,2.673,20.122,20.122,0,0,1-2.772,2.043c.021.1.036.2.05.3-.059-.07-.117-.147-.175-.224-.557-.714-1.2-1.581-1.807-2.484a14.735,14.735,0,0,1-1.763-3.372v-.007a3.423,3.423,0,0,1-.175-.868l-.695-.924.226-.252,1.843-2.071.4-.448.79.987s1.017-.35,4.272,2.33A23.361,23.361,0,0,1,199.548,106.347Z",
    transform: "translate(-165.485 -76.978)",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1521",
    "data-name": "Group 1521",
    transform: "translate(15.4 134.333)"
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 21.108,
    cy: 20.191,
    rx: 21.108,
    ry: 20.191,
    fill: "#ff725e"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    d: "M108.331,270.294a18.834,18.834,0,0,1-4.579,12.293,20.028,20.028,0,0,1-2.889,2.778c-.336.266-.688.525-1.053.77a20.031,20.031,0,0,1-3.16,1.784,21.123,21.123,0,0,1-18.944-.791,19.072,19.072,0,0,1-2.216-1.434h-.007a1.252,1.252,0,0,1-.11-.091,17.814,17.814,0,0,1-2.3-2.029,18.908,18.908,0,0,1-5.486-13.28c0-10.747,9.136-19.493,20.371-19.493S108.331,259.547,108.331,270.294Z",
    transform: "translate(-66.848 -250.104)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1520",
    "data-name": "Group 1520",
    transform: "translate(6.22 5.104)"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    d: "M103.723,287.4c-.336.266-.688.525-1.053.77a20.031,20.031,0,0,1-3.16,1.784,21.123,21.123,0,0,1-18.944-.791,19.071,19.071,0,0,1-2.216-1.434h-.007a1.254,1.254,0,0,1-.11-.091c.015-.049.022-.084.037-.133V287.5c.176-.63.344-1.287.5-1.973.219-.924.417-1.882.592-2.883a40.823,40.823,0,0,0,.614-8.242c-.358-10.32,1.6-14.106,6.012-16.128.2-.091.4-.189.622-.273a6.156,6.156,0,0,1,3.109-.371h.007c3.774.49,7.051,3.855,7.051,3.855a23.578,23.578,0,0,1,1.726,2.792,45.011,45.011,0,0,1,5.069,17.8v.007A50.228,50.228,0,0,1,103.723,287.4Z",
    transform: "translate(-75.928 -257.242)",
    fill: "#263238"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    d: "M102.723,291.982v-.007a6.2,6.2,0,0,0-2.128-1.064s-4.3-.4-8.039-.371c-.41.014-.827.035-1.236.056-1.916.1-3.833.287-5.727.56-.556.077-1.112.161-1.66.259q-2.743.43-5.42,1.126c-.856.217-1.7.455-2.553.714a6.5,6.5,0,0,0-.878,2.253,17.811,17.811,0,0,0,2.3,2.029,1.252,1.252,0,0,0,.11.091H77.5a19.072,19.072,0,0,0,2.216,1.434,21.123,21.123,0,0,0,18.944.791,20.033,20.033,0,0,0,3.16-1.784c.366-.245.717-.5,1.053-.77a20.027,20.027,0,0,0,2.889-2.778A27.656,27.656,0,0,0,102.723,291.982Z",
    transform: "translate(-75.082 -267.142)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M102.723,291.982v-.007a6.2,6.2,0,0,0-2.128-1.064s-4.3-.4-8.039-.371c-.41.014-.827.035-1.236.056-1.916.1-3.833.287-5.727.56-.556.077-1.112.161-1.66.259q-2.743.43-5.42,1.126c-.856.217-1.7.455-2.553.714a6.5,6.5,0,0,0-.878,2.253,17.811,17.811,0,0,0,2.3,2.029,1.252,1.252,0,0,0,.11.091H77.5a19.072,19.072,0,0,0,2.216,1.434,21.123,21.123,0,0,0,18.944.791,20.033,20.033,0,0,0,3.16-1.784c.366-.245.717-.5,1.053-.77a20.027,20.027,0,0,0,2.889-2.778A27.656,27.656,0,0,0,102.723,291.982Z",
    transform: "translate(-75.082 -267.142)",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M94.548,292.086c-4.737-.581-6.161-2.519-6.161-2.519,1.936-1.744,1.584-4.321,1.09-5.928a8.937,8.937,0,0,0-.584-1.482l5.7,1.02a15,15,0,0,0-.221,2.3,6.617,6.617,0,0,0,.161,1.687c.388,1.63,1.359,1.653,1.359,1.653C96.9,290.6,94.548,292.086,94.548,292.086Z",
    transform: "translate(-78.655 -264.625)",
    fill: "#eec1bb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M94.56,285.475a6.617,6.617,0,0,0,.161,1.687c-2.264-.285-3.98-2.018-5.059-3.522a8.937,8.937,0,0,0-.584-1.482l5.7,1.02A15,15,0,0,0,94.56,285.475Z",
    transform: "translate(-78.841 -264.625)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1519",
    "data-name": "Group 1519",
    transform: "translate(5.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M92.833,262.03c4.958.176,6.456,2.772,6.629,7.673.217,6.124-1.367,10.414-7.516,8.889C83.6,276.521,84.6,261.738,92.833,262.03Z",
    transform: "translate(-83.327 -258.579)",
    fill: "#eec1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M99.982,272.456a9.994,9.994,0,0,0,1.366,2.019,1.386,1.386,0,0,1-1.328.49Z",
    transform: "translate(-87.042 -261.712)",
    fill: "#d4827d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M92.886,267.835a.263.263,0,0,1-.17-.061.241.241,0,0,1-.024-.35,2.914,2.914,0,0,1,2.416-.721.248.248,0,0,1,.212.284.258.258,0,0,1-.3.2,2.421,2.421,0,0,0-1.941.56A.263.263,0,0,1,92.886,267.835Z",
    transform: "translate(-85.067 -259.975)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M102.763,267.54a.268.268,0,0,1-.151-.048,2.143,2.143,0,0,0-1.731-.425.262.262,0,0,1-.325-.161.244.244,0,0,1,.165-.31,2.648,2.648,0,0,1,2.194.494.241.241,0,0,1,.059.346A.264.264,0,0,1,102.763,267.54Z",
    transform: "translate(-87.193 -259.933)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1518",
    "data-name": "Group 1518",
    transform: "translate(8.833 14.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M97.717,278.241a11.64,11.64,0,0,0-.643,1.627c-.106-.012-.212-.023-.317-.04-1.438-.191-2.039-.734-2.27-1.278a1.717,1.717,0,0,1-.11-.841,1.681,1.681,0,0,1,.111-.473,7.041,7.041,0,0,0,2.74.932C97.527,278.221,97.717,278.241,97.717,278.241Z",
    transform: "translate(-94.366 -277.236)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M97.232,278.168l-.2.475a4.427,4.427,0,0,1-2.649-.934,1.681,1.681,0,0,1,.111-.473A7.041,7.041,0,0,0,97.232,278.168Z",
    transform: "translate(-94.37 -277.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M96.8,280.392c-1.438-.191-2.039-.734-2.27-1.278a4.833,4.833,0,0,1,1.553.514A1.707,1.707,0,0,1,96.8,280.392Z",
    transform: "translate(-94.411 -277.8)",
    fill: "#de5753"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_554",
    "data-name": "Path 554",
    d: "M86.637,269.014s2.469-3.815,2.235-6.836c0,0,9.975-3.491,10.09,6.066,0,0,1.289-8.437-7.228-8.929s-8.943,11.438-4.678,15.149C87.055,274.464,85.108,271.4,86.637,269.014Z",
    transform: "translate(-82.86 -257.761)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_555",
    "data-name": "Path 555",
    d: "M87.2,273.8a2.137,2.137,0,0,0-2.268-1.984c-1.543.106-2.392,3.1,1.4,3.959C86.874,275.9,87.2,275.4,87.2,273.8Z",
    transform: "translate(-82.648 -261.518)",
    fill: "#eec1bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_556",
    "data-name": "Path 556",
    d: "M89.011,257.416c2.681-.713,9.831-.807,11.519,6.269l-.993.475a16.361,16.361,0,0,0-5.363-1.52,11.7,11.7,0,0,0-1.39-1.9,10.175,10.175,0,0,1,0,1.8s-4.664.654-6.753,2.47c-3.278,2.85-3.476,4.655-3.476,4.655S80.285,259.735,89.011,257.416Z",
    transform: "translate(-82.291 -257.1)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_557",
    "data-name": "Path 557",
    d: "M103.483,263.664a.178.178,0,0,1-.17-.117,8.364,8.364,0,0,0-4.313-5.1c-3.677-1.73-8.026-.32-8.07-.306a.179.179,0,0,1-.227-.1.169.169,0,0,1,.11-.218c.045-.015,4.536-1.471,8.345.322a8.7,8.7,0,0,1,4.5,5.3.169.169,0,0,1-.113.215A.179.179,0,0,1,103.483,263.664Z",
    transform: "translate(-84.547 -257.145)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M93.991,271.61s1.161-.944,1.711.326A3.6,3.6,0,0,0,93.991,271.61Z",
    transform: "translate(-85.433 -261.356)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M101.531,272.457s.643-1.286,1.5-.376A3.455,3.455,0,0,0,101.531,272.457Z",
    transform: "translate(-87.458 -261.501)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1525",
    "data-name": "Group 1525",
    transform: "translate(203.164 153.824)"
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_647",
    "data-name": "Path 647",
    d: "M25.591.568A27.006,27.006,0,0,1,51.75,26.727,24.262,24.262,0,0,1,26.727,51.75,27.006,27.006,0,0,1,.568,25.591,24.262,24.262,0,0,1,25.591.568Z",
    transform: "translate(0 35.388) rotate(-45)",
    fill: "#ff725e"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M389.95,317.8a23.249,23.249,0,0,1-2.714,10.922c-.344.658-.724,1.294-1.126,1.917-.315.483-.644.959-1,1.42a24.9,24.9,0,0,1-5.3,5.171c-.461.336-.936.651-1.426.959a25.678,25.678,0,0,1-6.371,2.862,26.492,26.492,0,0,1-17.993-1.1c-.41-.182-.819-.371-1.222-.567v-.007a25.45,25.45,0,0,1-6.159-4.31,24.611,24.611,0,0,1-4.484-5.7c-.336-.6-.651-1.224-.936-1.854h-.007a23.282,23.282,0,0,1-2.114-9.712c0-13.406,11.41-24.321,25.432-24.321S389.95,304.39,389.95,317.8Z",
    transform: "translate(-327.528 -282.411)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>",
    transform: "translate(13.686 15.291)"
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M352.957,323.534a12.786,12.786,0,0,1-1.573,1.819l-2.194,9.928-1.434,6.479a24.61,24.61,0,0,1-4.484-5.7c.176-.525.366-1.071.549-1.623,1.551-4.6,3.335-9.935,3.467-10.46.234-.938-.622-5.534-.424-6.381s4.586-1.833,5.537-1.819S353.279,322.94,352.957,323.534Z",
    transform: "translate(-342.337 -304.399)",
    fill: "#9f5b53"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M356.044,342.381a.118.118,0,0,1-.007.035l-.922,9.047-.322,3.093c-.41-.182-.819-.371-1.222-.567v-.007a25.449,25.449,0,0,1-6.159-4.31,24.61,24.61,0,0,1-4.484-5.7c-.336-.6-.651-1.224-.936-1.854l1.485.231,5.369.847,1.156.182-1.353,6.276S353.572,343.095,356.044,342.381Z",
    transform: "translate(-341.993 -312.309)",
    fill: "#ff725e"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M356.044,342.381a.118.118,0,0,1-.007.035l-.922,9.047-.322,3.093c-.41-.182-.819-.371-1.222-.567v-.007a25.449,25.449,0,0,1-6.159-4.31,24.61,24.61,0,0,1-4.484-5.7c-.336-.6-.651-1.224-.936-1.854l1.485.231,5.369.847,1.156.182-1.353,6.276S353.572,343.095,356.044,342.381Z",
    transform: "translate(-341.993 -312.309)",
    opacity: 0.3
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1522",
    "data-name": "Group 1522",
    transform: "translate(11.579 28.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M392.267,342.633c-.344.658-.724,1.294-1.126,1.917-.315.483-.644.959-1,1.42a24.9,24.9,0,0,1-5.3,5.171c-.461.336-.936.651-1.426.959a25.68,25.68,0,0,1-6.371,2.862,26.492,26.492,0,0,1-17.993-1.1c-.41-.182-.819-.371-1.222-.567v-.007a76.956,76.956,0,0,1,2.465-11.566.118.118,0,0,0,.007-.035,54.933,54.933,0,0,1,8.046-1.567c.044,0,.08-.007.124-.007h.007a106.457,106.457,0,0,1,11.769-.238h.037a58.37,58.37,0,0,1,8.112.77A22.627,22.627,0,0,1,392.267,342.633Z",
    transform: "translate(-357.823 -339.811)",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M392.267,342.633c-.344.658-.724,1.294-1.126,1.917-.315.483-.644.959-1,1.42a24.9,24.9,0,0,1-5.3,5.171c-.461.336-.936.651-1.426.959a25.68,25.68,0,0,1-6.371,2.862,26.492,26.492,0,0,1-17.993-1.1c-.41-.182-.819-.371-1.222-.567v-.007a76.956,76.956,0,0,1,2.465-11.566.118.118,0,0,0,.007-.035,54.933,54.933,0,0,1,8.046-1.567c.044,0,.08-.007.124-.007h.007a106.457,106.457,0,0,1,11.769-.238h.037a58.37,58.37,0,0,1,8.112.77A22.627,22.627,0,0,1,392.267,342.633Z",
    transform: "translate(-357.823 -339.811)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M384.835,352.2c-.461.336-.936.651-1.426.959a25.68,25.68,0,0,1-6.371,2.862,26.492,26.492,0,0,1-17.993-1.1c-.41-.182-.819-.371-1.222-.567v-.007c.037-.2.066-.406.1-.6a22.649,22.649,0,0,1,1.448-1.917,66.788,66.788,0,0,1,8.17-7.983,4.715,4.715,0,0,0,2.845,1.413c2.4.448,5.142-.623,7.417-1.917a54.233,54.233,0,0,1,3.986,4.205,22.149,22.149,0,0,1,2.7,3.876Q384.682,351.825,384.835,352.2Z",
    transform: "translate(-357.823 -340.872)",
    fill: "#fff",
    opacity: 0.8
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M384.042,334.443a12.523,12.523,0,0,1-8.661,3.759c-4.926.208-3.278-3.516-3.278-3.516a4.7,4.7,0,0,0,3.316-2.248,6.3,6.3,0,0,0,.045-4.375l-.09-.323,7.194-6.129C381.9,325.3,381.3,332.045,384.042,334.443Z",
    transform: "translate(-350.008 -306.152)",
    fill: "#9f5b53"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M382.7,327.912c-.382,2.363-3.384,4.691-5.966,5.421a6.3,6.3,0,0,0,.045-4.375l5.958-4.368A8.549,8.549,0,0,1,382.7,327.912Z",
    transform: "translate(-351.323 -307.046)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1524",
    "data-name": "Group 1524",
    transform: "translate(18.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M376.3,309.292c1.708,1.844.161,3.886-5.459,6.3-1.268-2.818-.364-7.465,1.45-8.246S374.8,307.692,376.3,309.292Z",
    transform: "translate(-368.397 -301.792)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_570",
    "data-name": "Path 570",
    d: "M383.516,314.8c-1.512,4.773-2.146,7.636-5.315,9.544a6.926,6.926,0,0,1-10.483-5.879c0-4.589,2.466-11.629,7.9-12.428a7.078,7.078,0,0,1,8.141,5.649A6.517,6.517,0,0,1,383.516,314.8Z",
    transform: "translate(-367.718 -301.448)",
    fill: "#9f5b53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_571",
    "data-name": "Path 571",
    d: "M378.161,317.683c-.1.394-.4.664-.666.6s-.4-.427-.307-.821.391-.664.66-.607S378.229,317.288,378.161,317.683Z",
    transform: "translate(-370.253 -304.722)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M371.752,316.172c-.1.394-.4.664-.666.6s-.412-.427-.314-.826.4-.664.666-.6S371.85,315.779,371.752,316.172Z",
    transform: "translate(-368.53 -304.268)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M373.12,317.292a14.748,14.748,0,0,1-2.807,2.925,2.508,2.508,0,0,0,1.885.8Z",
    transform: "translate(-368.415 -304.855)",
    fill: "#892b29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M380.123,315.7a.255.255,0,0,0,.162,0,.237.237,0,0,0,.132-.313,2.431,2.431,0,0,0-1.734-1.4.239.239,0,0,0-.283.178l0,.017a.248.248,0,0,0,.2.274h0a1.936,1.936,0,0,1,1.357,1.121A.256.256,0,0,0,380.123,315.7Z",
    transform: "translate(-370.585 -303.86)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M369.65,313.124a.265.265,0,0,0,.253-.082,2.013,2.013,0,0,1,1.622-.738.25.25,0,0,0,.274-.213.243.243,0,0,0-.217-.262,2.526,2.526,0,0,0-2.063.914.228.228,0,0,0,.032.331l0,0A.288.288,0,0,0,369.65,313.124Z",
    transform: "translate(-368.187 -303.213)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M387.24,311.728c-2.559.239-2.875,2.746-.465,8.166,2.934-1.242,5.575-5.243,4.789-6.99S389.476,311.523,387.24,311.728Z",
    transform: "translate(-372.395 -303.13)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M389.416,323.507a4.93,4.93,0,0,1-2.978,2.239c-1.676.434-2.5-1-2.024-2.51.429-1.357,1.822-3.219,3.5-2.987A2.1,2.1,0,0,1,389.416,323.507Z",
    transform: "translate(-372.166 -305.737)",
    fill: "#9f5b53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M377.82,306.1s-.536,5.02,4.248,6.513,6.6-1.127,6.6-1.127a9.7,9.7,0,0,1-1.223-.2,4.864,4.864,0,0,0,1.232-4.617c-.817-2.617-5.039-6.164-8.965-5.826a9.16,9.16,0,0,0-6.982-1.032c-3.874,1.052-4.365,5.28-4.365,5.28s.512-2.516,2.269-2.826c0,0-3.308,4.631-.752,6.705C369.882,308.972,371.512,304.018,377.82,306.1Z",
    transform: "translate(-367.892 -299.516)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1523",
    "data-name": "Group 1523",
    transform: "translate(2.885 16.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M371.662,324.529a13.258,13.258,0,0,1,.971,1.707c.116-.029.232-.057.346-.091,1.561-.422,2.139-1.111,2.308-1.747a1.919,1.919,0,0,0-.013-.947,1.867,1.867,0,0,0-.2-.507,7.782,7.782,0,0,1-2.883,1.434C371.87,324.479,371.662,324.529,371.662,324.529Z",
    transform: "translate(-371.662 -322.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    "data-name": "Path 580",
    d: "M372.386,324.377l.3.5c1.469-.4,2.447-.872,2.782-1.423a1.867,1.867,0,0,0-.2-.507A7.782,7.782,0,0,1,372.386,324.377Z",
    transform: "translate(-371.856 -322.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_581",
    "data-name": "Path 581",
    d: "M373.463,326.769c1.561-.422,2.139-1.111,2.308-1.747a5.3,5.3,0,0,0-1.636.8A1.873,1.873,0,0,0,373.463,326.769Z",
    transform: "translate(-372.146 -323.567)",
    fill: "#de5753"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_bubble",
    "data-name": "Speech bubble",
    transform: "translate(183.268 109.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1526",
    "data-name": "Group 1526"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_649",
    "data-name": "Path 649",
    d: "M2.7-.006l10.03-.021a2.631,2.631,0,0,1,2.695,2.578l-.021,9.6A2.658,2.658,0,0,1,12.7,14.738l-10.03.021A2.631,2.631,0,0,1-.026,12.18l.021-9.6A2.658,2.658,0,0,1,2.7-.006Z",
    transform: "matrix(0.999, 0.048, -0.048, 0.999, 0.737, 0)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    "data-name": "Path 582",
    d: "M264.273,144.6c-1-1.742-3.117-1.187-4.257.078-1.009-1.363-3.057-2.108-4.23-.467-1.978,2.767,1.673,5.582,3.408,6.7.2.128.359.234.494.317.143-.071.316-.16.524-.27C262.051,150.009,265.966,147.54,264.273,144.6Z",
    transform: "translate(-251.808 -139.587)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_583",
    "data-name": "Path 583",
    d: "M260.926,157.9a11.777,11.777,0,0,1-6.842,5.506s2.574-1.268,2.612-5.884Z",
    transform: "translate(-251.505 -143.864)",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(136.863 124.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1536",
    "data-name": "Group 1536",
    transform: "translate(0 0)"
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    d: "M279.506,216.156s5.807-5.558,7.678-9.514c0,0-.707-2.213-.044-3.357s4.531-4.432,5.563-3.736,2.527,3.454,1.909,4.611-4.41,3.522-4.41,3.522-4.7,9.02-7.614,11.055S279.506,216.156,279.506,216.156Z",
    transform: "translate(-211.926 -171.397)",
    fill: "#ebb376"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    d: "M259.2,199.453c3.383.421,7.241,16.106,9.942,17.582s9.709-7.193,9.709-7.193l3.215,3.509s-9.259,12.342-12.925,11.242-10.558-13.278-10.558-13.278Z",
    transform: "translate(-206.309 -171.397)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    d: "M259.2,199.453c3.383.421,7.241,16.106,9.942,17.582s9.709-7.193,9.709-7.193l3.215,3.509s-9.259,12.342-12.925,11.242-10.558-13.278-10.558-13.278Z",
    transform: "translate(-206.309 -171.397)",
    fill: "#fff",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    d: "M284.581,401.061l-4.443.75-1.822-5.795-1.662-5.318,5.122-1.711,1.487,6.392Z",
    transform: "translate(-211.161 -228.318)",
    fill: "#ebb376"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_588",
    "data-name": "Path 588",
    d: "M280.048,406.675c-.075-.47,6.01-1.119,6.01-1.119s4.367,2.976,8.113,3.179,2.117,2.606-1.9,3.284l-9.943,1.679C279.47,414.181,280.825,411.552,280.048,406.675Z",
    transform: "translate(-212.072 -233.294)",
    fill: "#263238"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1527",
    "data-name": "Group 1527",
    transform: "translate(74.678 170.619)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_589",
    "data-name": "Path 589",
    d: "M291.509,405.822a9.841,9.841,0,0,1-2.18-.341.151.151,0,0,1-.053-.024h0a.153.153,0,0,1-.041-.042h0a.133.133,0,0,1-.017-.037h0a.156.156,0,0,1,0-.069c.012-.066.27-1.492,1.025-1.953a.978.978,0,0,1,.783-.112c.3.078.46.219.485.418.037.306-.335.681-.779,1.015a2.629,2.629,0,0,1,1.376-.087.649.649,0,0,1,.394.335.543.543,0,0,1-.032.639A1.321,1.321,0,0,1,291.509,405.822Zm-1.648-.531c.954.21,2.114.341,2.357.069.021-.024.086-.1-.016-.311a.337.337,0,0,0-.21-.172A4.144,4.144,0,0,0,289.861,405.291Zm.888-1.776a.637.637,0,0,0-.338.1,2.543,2.543,0,0,0-.8,1.412c.832-.475,1.61-1.068,1.578-1.329-.01-.082-.161-.133-.25-.156A.724.724,0,0,0,290.749,403.515Z",
    transform: "translate(-289.21 -403.207)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_590",
    "data-name": "Path 590",
    d: "M283.292,395.522l-4.95.623-1.673-5.377,5.117-1.741Z",
    transform: "translate(-211.165 -228.33)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_591",
    "data-name": "Path 591",
    d: "M244.767,403.542h-4.511l-.741-6.009-.67-5.514,5.356-.833.3,6.542Z",
    transform: "translate(-201.006 -228.978)",
    fill: "#ebb376"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_592",
    "data-name": "Path 592",
    d: "M239.206,408.347c.012-.476,6.123-.1,6.123-.1s3.759,3.658,7.411,4.479,1.611,2.918-2.47,2.918h-10.1C237.273,415.642,239.085,413.279,239.206,408.347Z",
    transform: "translate(-200.924 -234.06)",
    fill: "#263238"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1528",
    "data-name": "Group 1528",
    transform: "translate(44.996 172.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_593",
    "data-name": "Path 593",
    d: "M251.255,409.259a7.918,7.918,0,0,1-2.532-.741.145.145,0,0,1-.054-.04h0a.191.191,0,0,1-.021-.032.151.151,0,0,1-.007-.118c.022-.058.535-1.422,1.363-1.753a.982.982,0,0,1,.791.021c.279.127.414.292.4.492-.018.307-.453.615-.95.869a2.593,2.593,0,0,1,1.37.143.63.63,0,0,1,.327.4.546.546,0,0,1-.148.623A.874.874,0,0,1,251.255,409.259Zm-1.973-.839c.9.365,2.02.688,2.308.46.025-.02.1-.08.04-.309a.329.329,0,0,0-.175-.2A4.171,4.171,0,0,0,249.281,408.42Zm1.093-1.61a.656.656,0,0,0-.247.05,2.593,2.593,0,0,0-1.049,1.257c.906-.33,1.78-.784,1.8-1.047,0-.082-.135-.158-.218-.2A.668.668,0,0,0,250.375,406.81Z",
    transform: "translate(-248.631 -406.502)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_594",
    "data-name": "Path 594",
    d: "M244.5,397.874l-4.988-.21-.67-5.573,5.356-.863Z",
    transform: "translate(-201.006 -228.991)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1529",
    "data-name": "Group 1529",
    transform: "translate(27.451 60.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_595",
    "data-name": "Path 595",
    d: "M269.739,349.353l-7.3,1.231A467.317,467.317,0,0,1,246.12,306.19c-1.994-6.565-3.548-12.4-4.742-17.584l.334,19.122v43.437H234.3c-18.042-82.306-5.256-101.114-5.256-101.114l21.584-3.528a89.728,89.728,0,0,1,1.807,11.555l.974,6.827,8.437,41.676Z",
    transform: "translate(-224.643 -246.522)",
    fill: "#ff725e"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_596",
    "data-name": "Path 596",
    d: "M274.746,392.783l9.059-2.873-.123,3.686-7.492,2.286Z",
    transform: "translate(-210.648 -228.595)",
    fill: "#ff725e"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_597",
    "data-name": "Path 597",
    d: "M236.515,394.022l9.444-1.322-.791,3.609-7.794,1Z",
    transform: "translate(-200.381 -229.433)",
    fill: "#ff725e"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_598",
    "data-name": "Path 598",
    d: "M255.512,183.777a.186.186,0,0,1-.094-.026c-2.753-1.591-5.209-7.434-5.312-7.682a.173.173,0,0,1,.1-.227.186.186,0,0,1,.237.1c.025.059,2.513,5.982,5.162,7.512a.17.17,0,0,1,.061.24A.184.184,0,0,1,255.512,183.777Z",
    transform: "translate(-204.027 -164.303)",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_599",
    "data-name": "Path 599",
    d: "M225.609,163.479s1.074-3.491,8.24-4.087a8.555,8.555,0,0,1,9.044,11.179s1.507,6.834,4.4,8.839c0,0-13.79,5.963-20.754,6-1.55.008-4.861-7.351-5.288-12.656C220.837,167.642,222.449,163.642,225.609,163.479Z",
    transform: "translate(-196.264 -159.355)",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_600",
    "data-name": "Path 600",
    d: "M230.653,246.221V249.3l22.011-1.614v-3.645Z",
    transform: "translate(-198.807 -184.789)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_601",
    "data-name": "Path 601",
    d: "M230.653,246.221V249.3l22.011-1.614v-3.645Z",
    transform: "translate(-198.807 -184.789)",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_648",
    "data-name": "Path 648",
    d: "M0,0,4.83.019l.014,3.507L.014,3.507Z",
    transform: "translate(43.955 60.418) rotate(-5.118)",
    fill: "#fff"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1530",
    "data-name": "Group 1530",
    transform: "translate(38.144 60.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_650",
    "data-name": "Path 650",
    d: "M0,0,1.093,0,1.105,5.33l-1.093,0Z",
    transform: "translate(0 0.053) rotate(-2.927)",
    fill: "#ff725e"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1531",
    "data-name": "Group 1531",
    transform: "translate(51.591 58.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    "data-name": "Path 651",
    d: "M0,0,1.093,0,1.105,5.33l-1.093,0Z",
    transform: "translate(0 0.053) rotate(-2.919)",
    fill: "#ff725e"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_602",
    "data-name": "Path 602",
    d: "M249.674,230.839l-22.016,1.819a89.215,89.215,0,0,0-.929-8.97c-.322-1.959-.768-4.058-1.412-6.5-.5-1.91-1.119-4.037-1.909-6.472-.037-.133-.08-.266-.124-.4-.453-1.392-3.679-.329-3.972-2-1.273-7.445,7.124-7.99,10.218-8.48a73.149,73.149,0,0,1,9.889-.994c4.279-.035,9.2.427,9.2.427s.7.161,1.141,4.506C250.164,207.847,250.559,216.005,249.674,230.839Z",
    transform: "translate(-195.726 -171.213)",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_603",
    "data-name": "Path 603",
    d: "M241.773,200.6c-5.426-.664-7.056-2.881-7.056-2.881,3.443-3.107.582-8.491.582-8.491l6.531,1.166a17.532,17.532,0,0,0-.255,2.63c-.05,3.792,1.743,3.829,1.743,3.829C244.464,198.912,241.773,200.6,241.773,200.6Z",
    transform: "translate(-199.898 -168.328)",
    fill: "#ebb376"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_604",
    "data-name": "Path 604",
    d: "M242.044,190.4a17.532,17.532,0,0,0-.255,2.63,7.252,7.252,0,0,1-6.276-3.8Z",
    transform: "translate(-200.112 -168.328)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1534",
    "data-name": "Group 1534",
    transform: "translate(29.553 2.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_605",
    "data-name": "Path 605",
    d: "M235.622,165.781c5.545-1.2,8,1.252,9.7,6.629,2.125,6.721,1.69,11.918-5.588,11.961C229.851,184.431,226.413,167.776,235.622,165.781Z",
    transform: "translate(-228.25 -163.624)",
    fill: "#ebb376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_606",
    "data-name": "Path 606",
    d: "M245.865,176.072a11.828,11.828,0,0,0,2.134,1.85,1.546,1.546,0,0,1-1.32.917Z",
    transform: "translate(-232.445 -166.804)",
    fill: "#d58745"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1532",
    "data-name": "Group 1532",
    transform: "translate(8.792 8.36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M240.669,176.218c.114.433-.039.843-.341.916s-.639-.22-.753-.653.039-.843.341-.916S240.555,175.784,240.669,176.218Z",
    transform: "translate(-239.537 -175.009)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M239.89,175.382l.889-.607S240.5,175.686,239.89,175.382Z",
    transform: "translate(-239.632 -174.775)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1533",
    "data-name": "Group 1533",
    transform: "translate(14.401 6.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M248.337,174.154c.113.434-.039.844-.341.917s-.639-.22-.753-.654.039-.844.341-.916S248.223,173.721,248.337,174.154Z",
    transform: "translate(-247.206 -172.946)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M247.558,173.319l.889-.607S248.164,173.623,247.558,173.319Z",
    transform: "translate(-247.3 -172.712)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M236.7,172.752a.276.276,0,0,1-.117-.026.249.249,0,0,1-.12-.34,3.231,3.231,0,0,1,2.428-1.463.263.263,0,0,1,.288.228.257.257,0,0,1-.238.276,2.747,2.747,0,0,0-2,1.183A.266.266,0,0,1,236.7,172.752Z",
    transform: "translate(-229.912 -165.258)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M245.164,169.748a.269.269,0,0,1-.224-.117.246.246,0,0,1,.078-.348,3.022,3.022,0,0,1,2.552-.067.249.249,0,0,1,.153.327.268.268,0,0,1-.342.147,2.488,2.488,0,0,0-2.076.019A.275.275,0,0,1,245.164,169.748Z",
    transform: "translate(-232.185 -164.675)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M245.119,183.172a13.2,13.2,0,0,0-.211,1.982c-.121.017-.243.035-.365.046-1.651.193-2.483-.239-2.906-.776a2,2,0,0,1-.38-.9,1.9,1.9,0,0,1-.023-.556,8.194,8.194,0,0,0,3.321.262C244.9,183.2,245.119,183.172,245.119,183.172Z",
    transform: "translate(-231.198 -168.875)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M244.555,183.23l-.078.583c-1.555.178-2.676.1-3.22-.289a1.9,1.9,0,0,1-.023-.556A8.194,8.194,0,0,0,244.555,183.23Z",
    transform: "translate(-231.198 -168.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M244.7,185.815c-1.651.193-2.483-.239-2.906-.776a5.584,5.584,0,0,1,1.878.132A2.012,2.012,0,0,1,244.7,185.815Z",
    transform: "translate(-231.35 -169.49)",
    fill: "#de5753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M230.946,175.237s1.561-4.92.372-8.2c0,0,9.972-6.675,13.04,3.877,0,0-1.17-9.707-10.752-7.853-9.567,1.851-6.383,15.185-.519,18.094C233.087,181.156,229.987,178.31,230.946,175.237Z",
    transform: "translate(-227.518 -162.827)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M232.279,181.159a2.514,2.514,0,0,0-3.122-1.559c-1.676.552-1.7,4.1,2.771,3.989C232.567,183.573,232.777,182.924,232.279,181.159Z",
    transform: "translate(-227.679 -167.825)",
    fill: "#ebb376"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M232.563,168.037s5.746-2.023,8.981-.5c0,0-3.487-2.993-9.39-.175Z",
    transform: "translate(-199.21 -161.397)",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M227.84,201.164s6.37,4.945,12.3,4.865,8.015-6.46,8.015-6.46A35.256,35.256,0,0,0,227.84,201.164Z",
    transform: "translate(-198.051 -171.192)",
    fill: "#ebb376"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M252.265,316.383c-1.994-6.565-3.548-12.4-4.742-17.584a155.027,155.027,0,0,1,1.394-18.337S252.078,304.114,252.265,316.383Z",
    transform: "translate(-203.337 -195.726)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_621",
    "data-name": "Path 621",
    d: "M199.078,209.675s-4.365-6.657-5.266-10.913c0,0,1.205-2.007.825-3.263s-3.383-5.288-4.552-4.828-3.269,2.828-2.936,4.087,3.478,4.374,3.478,4.374,2.48,9.8,4.844,12.4S199.078,209.675,199.078,209.675Z",
    transform: "translate(-187.114 -168.749)",
    fill: "#ebb376"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_622",
    "data-name": "Path 622",
    d: "M212.33,206.661c2.22-.294,6.7,3.849,6.016,7.433s-6.954,13.656-11.794,12.873c-6.839-1.108-14.353-18.352-14.353-18.352l3.753-3.129s8.855,14.674,10.6,14.386S212.33,206.661,212.33,206.661Z",
    transform: "translate(-188.479 -173.209)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_623",
    "data-name": "Path 623",
    d: "M212.33,206.661c2.22-.294,6.7,3.849,6.016,7.433s-6.954,13.656-11.794,12.873c-6.839-1.108-14.353-18.352-14.353-18.352l3.753-3.129s8.855,14.674,10.6,14.386S212.33,206.661,212.33,206.661Z",
    transform: "translate(-188.479 -173.209)",
    fill: "#fff",
    opacity: 0.05,
    style: {
      isolation: "isolate"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M190.1,207.1l5.478-3.145.868,1.356-5.169,4.376Z",
    transform: "translate(-187.917 -172.75)",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M284.626,213.808l4.437,5.252.772-1.648-3.987-4.434Z",
    transform: "translate(-213.302 -175.459)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1535",
    "data-name": "Group 1535",
    transform: "translate(73.109 22.515)"
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M287.6,200.4l7.012-8.169a.681.681,0,0,1,.964-.058L298.7,195a.612.612,0,0,1,.059.859l-7.12,8.357a.681.681,0,0,1-.989.038l-3.017-3.011A.611.611,0,0,1,287.6,200.4Z",
    transform: "translate(-287.17 -191.675)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M287.6,200.4l7.012-8.169a.681.681,0,0,1,.964-.058L298.7,195a.612.612,0,0,1,.059.859l-7.12,8.357a.681.681,0,0,1-.989.038l-3.017-3.011A.611.611,0,0,1,287.6,200.4Z",
    transform: "translate(-287.17 -191.675)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M287.217,199.934l7.012-8.169a.681.681,0,0,1,.964-.059l3.125,2.823a.612.612,0,0,1,.059.859l-7.12,8.357a.68.68,0,0,1-.989.038l-3.017-3.01A.611.611,0,0,1,287.217,199.934Z",
    transform: "translate(-287.066 -191.534)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M294.788,192.333l3.466,3.206-6.78,7.979L288.1,200.13Z",
    transform: "translate(-287.344 -191.774)",
    fill: "#fff",
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.d7860a4f0f551e5254ef6fa707f0c6e4.svg";
export { ForwardRef as ReactComponent };